(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-category-filter-core"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.NativeCategoryFilter) {
      return;
    }

    var FILTER_PARAM_SEPARATOR = '+';
    var FILTER_PARAM_ORDER = ['category_filter', 'variant_filter', 'custom_filter'];
    // Canonical control by category level
    var CANONICAL_LEVEL_1_ENABLED = true;
    var CANONICAL_LEVEL_2_ENABLED = true;
    var CANONICAL_LEVEL_3_ENABLED = true;
    var CANONICAL_MAX_DEPTH_METAFIELD =
      window.NativeCategoryFilterConfig && window.NativeCategoryFilterConfig.canonicalMaxDepth != null
        ? window.NativeCategoryFilterConfig.canonicalMaxDepth
        : 1;

    function normalizeCanonicalMaxDepth(value) {
      var depth = parseInt(value, 10);
      if (isNaN(depth) || depth < 1) {
        return 1;
      }
      if (depth > 3) {
        return 3;
      }
      return depth;
    }

    var CANONICAL_MAX_DEPTH = normalizeCanonicalMaxDepth(CANONICAL_MAX_DEPTH_METAFIELD);

    function isCanonicalLevelEnabled(level) {
      if (level === 1) {
        return CANONICAL_LEVEL_1_ENABLED && CANONICAL_MAX_DEPTH >= 1;
      }
      if (level === 2) {
        return CANONICAL_LEVEL_2_ENABLED && CANONICAL_MAX_DEPTH >= 2;
      }
      if (level === 3) {
        return CANONICAL_LEVEL_3_ENABLED && CANONICAL_MAX_DEPTH >= 3;
      }
      return false;
    }

    var state = {
      initialized: false,
      tree: [],
      rootHandles: [],
      nodes: new Map(),
      nodesById: new Map(),
      explicit: new Set(),
      derivedCounts: new Map(),
      drillPath: [],
      sidebarOpen: false,
      listeners: new Set(),
      lastSelectionHandle: null,
      multiRootCache: false,
      multiSelectionCache: false,
      urlApplied: false,
    };
    // Capture original canonical once so we can restore it when needed (ie: Multiple root selections)
    var canonicalBase = null;
    var canonicalBaseReady = false;

    function toHandle(value) {
      return (value || '').toString();
    }

    function splitFilterParam(value) {
      if (typeof value !== 'string' || value.length === 0) {
        return [];
      }

      if (FILTER_PARAM_SEPARATOR === '+' && value.indexOf(' ') !== -1) {
        value = value.replace(/ /g, '+');
      }

      return value.split(FILTER_PARAM_SEPARATOR);
    }

    function getCanonicalElement() {
      if (typeof document === 'undefined') {
        return null;
      }

      return document.querySelector('link[rel="canonical"]');
    }

    function getCanonicalBase() {
      if (canonicalBaseReady) {
        return canonicalBase;
      }

      canonicalBaseReady = true;
      var element = getCanonicalElement();
      canonicalBase = element ? element.getAttribute('href') || '' : null;
      return canonicalBase;
    }

    function buildCanonicalCategoryParam(rootHandle) {
      if (!rootHandle) {
        return null;
      }

      var rootToken = getUrlHandleToken(rootHandle);
      if (!rootToken) {
        return null;
      }

      var level1Enabled = isCanonicalLevelEnabled(1);
      var level2Enabled = isCanonicalLevelEnabled(2);
      var level3Enabled = isCanonicalLevelEnabled(3);

      if (!level1Enabled && !level2Enabled && !level3Enabled) {
        return null;
      }

      var categoryPaths = [];

      computeCombinedPaths().forEach(function (path) {
        if (!Array.isArray(path) || path.length === 0) {
          return;
        }

        if (isVariantScentPath(path)) {
          return;
        }

        if (path[0] !== rootHandle) {
          return;
        }

        categoryPaths.push(path);
      });

      if (categoryPaths.length === 0) {
        return CANONICAL_LEVEL_1_ENABLED ? rootToken : null;
      }

      var level2Handles = new Set();
      var level3Handles = new Set();

      categoryPaths.forEach(function (path) {
        if (path.length >= 2) {
          var level2Token = getUrlHandleToken(path[1]);
          if (level2Token) {
            level2Handles.add(level2Token);
          }
        }

        if (path.length >= 3) {
          var level3Token = getUrlHandleToken(path[2]);
          if (level3Token) {
            level3Handles.add(level3Token);
          }
        }
      });

      var level2Handle = level2Handles.size === 1 ? level2Handles.values().next().value : null;
      var level3Handle = level3Handles.size === 1 ? level3Handles.values().next().value : null;

      if (level3Enabled && level2Handle && level3Handle) {
        return [rootToken, level2Handle, level3Handle].join('_');
      }

      if (level2Enabled && level2Handle) {
        return [rootToken, level2Handle].join('_');
      }

      if (level1Enabled) {
        return rootToken;
      }

      return null;
    }

    function updateCanonicalUrl() {
      if (typeof window === 'undefined') {
        return;
      }

      var canonicalElement = getCanonicalElement();
      if (!canonicalElement) {
        return;
      }

      var baseHref = getCanonicalBase();
      if (!baseHref) {
        return;
      }

      // Only one level 1 category selection should update the canonical URL
      var rootHandles = computeRootHandles();

      if (rootHandles.size !== 1) {
        if (canonicalElement.getAttribute('href') !== baseHref) {
          canonicalElement.setAttribute('href', baseHref);
        }
        return;
      }

      var rootHandle = null;
      rootHandles.forEach(function (handle) {
        if (!rootHandle) {
          rootHandle = handle;
        }
      });

      if (!rootHandle) {
        if (canonicalElement.getAttribute('href') !== baseHref) {
          canonicalElement.setAttribute('href', baseHref);
        }
        return;
      }

      var canonicalCategoryParam = buildCanonicalCategoryParam(rootHandle);
      if (!canonicalCategoryParam) {
        if (canonicalElement.getAttribute('href') !== baseHref) {
          canonicalElement.setAttribute('href', baseHref);
        }
        return;
      }

      var url;
      try {
        url = new URL(baseHref);
      } catch (error) {
        return;
      }

      // Reset query params before applying the single category_filter
      url.search = '';
      url.searchParams.set('category_filter', canonicalCategoryParam);
      var nextHref = url.toString();

      if (canonicalElement.getAttribute('href') !== nextHref) {
        canonicalElement.setAttribute('href', nextHref);
      }
    }

    function getHandleGroupType(handle) {
      if (!handle) {
        return '';
      }

      var node = state.nodes.get(handle);
      if (!node || !node.data) {
        return '';
      }

      return node.data.group_type || '';
    }

    function isVariantScentHandle(handle) {
      return getHandleGroupType(handle) === 'variant_scent';
    }

    function isCustomSidebarHandle(handle) {
      return getHandleGroupType(handle) === 'sidebar_custom';
    }

    function isNonCategoryHandle(handle) {
      return isVariantScentHandle(handle) || isCustomSidebarHandle(handle);
    }

    function isVariantScentPath(path) {
      if (!Array.isArray(path) || path.length === 0) {
        return false;
      }

      return isNonCategoryHandle(path[path.length - 1]);
    }

    function countCategorySelections(paths) {
      if (!Array.isArray(paths)) {
        return 0;
      }

      var count = 0;

      paths.forEach(function (path) {
        if (!isVariantScentPath(path)) {
          count += 1;
        }
      });

      return count;
    }

    function getLastCategorySelectionHandle() {
      if (
        state.lastSelectionHandle &&
        state.explicit.has(state.lastSelectionHandle) &&
        !isNonCategoryHandle(state.lastSelectionHandle)
      ) {
        return state.lastSelectionHandle;
      }

      var handles = [];

      state.explicit.forEach(function (entry) {
        handles.push(entry);
      });

      for (var i = handles.length - 1; i >= 0; i -= 1) {
        var candidate = handles[i];
        if (!isNonCategoryHandle(candidate)) {
          return candidate;
        }
      }

      return null;
    }

    function resolveHandle(entry) {
      var candidate =
        entry.handle ||
        entry.metaobject_handle ||
        entry.id ||
        (entry.name ? entry.name.replace(/\s+/g, '-').toLowerCase() : '');

      candidate = toHandle(candidate);

      if (!candidate) {
        candidate = 'category-' + (state.nodes.size + 1);
      }

      var handle = candidate;
      var suffix = 1;

      while (state.nodes.has(handle)) {
        suffix += 1;
        handle = candidate + '-' + suffix;
      }

      return handle;
    }

    function getUrlHandleTokenFromNode(node) {
      if (!node) {
        return '';
      }

      var data = node.data || {};
      var token = data.metaobject_handle || data.handle || node.handle || '';
      token = toHandle(token).trim();

      if (!token) {
        token = toHandle(node.handle).trim();
      }

      return token;
    }

    function getUrlHandleToken(handle) {
      var normalized = toHandle(handle);
      var node = state.nodes.get(normalized);

      if (!node) {
        return normalized;
      }

      return getUrlHandleTokenFromNode(node);
    }

    function buildTree(filters) {
      state.tree = Array.isArray(filters) ? filters : [];
      state.nodes.clear();
      state.nodesById.clear();
      state.rootHandles = [];

      function traverse(entry, parentNode) {
        if (!entry) {
          return null;
        }

        var handle = resolveHandle(entry);
        var depth = parentNode ? parentNode.depth + 1 : 0;
        var path = parentNode ? parentNode.path.concat(handle) : [handle];

        var node = {
          id: entry.id,
          handle: handle,
          name: entry.name || handle,
          data: entry,
          depth: depth,
          parent: parentNode ? parentNode.handle : null,
          path: path,
          children: [],
        };

        state.nodes.set(handle, node);
        if (entry.id) {
          var idKey = toHandle(entry.id);
          if (idKey && !state.nodesById.has(idKey)) {
            state.nodesById.set(idKey, handle);
          }
        }

        if (!parentNode) {
          state.rootHandles.push(handle);
        } else {
          parentNode.children.push(handle);
        }

        var children = Array.isArray(entry.children) ? entry.children : [];

        children.forEach(function (childEntry) {
          traverse(childEntry, node);
        });

        return node;
      }

      state.tree.forEach(function (entry) {
        traverse(entry, null);
      });
    }

    function adjustDerived(handle, delta) {
      var current = state.derivedCounts.get(handle) || 0;
      var next = current + delta;

      if (next <= 0) {
        state.derivedCounts.delete(handle);
        return;
      }

      state.derivedCounts.set(handle, next);
    }

    function updateAncestors(handle, delta) {
      var node = state.nodes.get(handle);

      while (node) {
        adjustDerived(node.handle, delta);
        if (!node.parent) {
          break;
        }
        node = state.nodes.get(node.parent);
      }
    }

    function getAncestors(handle) {
      var ancestors = [];
      var node = state.nodes.get(handle);

      while (node && node.parent) {
        var parentNode = state.nodes.get(node.parent);
        if (!parentNode) {
          break;
        }
        ancestors.push(parentNode.handle);
        node = parentNode;
      }

      return ancestors;
    }

    function getDescendants(handle) {
      var results = [];
      var node = state.nodes.get(handle);

      if (!node) {
        return results;
      }

      var queue = Array.isArray(node.children) ? node.children.slice() : [];

      while (queue.length > 0) {
        var childHandle = queue.shift();
        results.push(childHandle);

        var childNode = state.nodes.get(childHandle);
        if (childNode && childNode.children.length > 0) {
          queue = queue.concat(childNode.children);
        }
      }

      return results;
    }

    function hasDerived(handle) {
      return (state.derivedCounts.get(handle) || 0) > 0;
    }

    function addExplicit(handle) {
      if (!state.nodes.has(handle) || state.explicit.has(handle)) {
        return false;
      }

      state.explicit.add(handle);
      updateAncestors(handle, 1);

      return true;
    }

    function removeExplicit(handle) {
      if (!state.explicit.has(handle)) {
        return false;
      }

      state.explicit.delete(handle);
      updateAncestors(handle, -1);

      if (state.lastSelectionHandle === handle) {
        state.lastSelectionHandle = null;
      }

      return true;
    }

    function clearExplicitAncestors(handle) {
      var ancestors = getAncestors(handle);

      ancestors.forEach(function (ancestorHandle) {
        removeExplicit(ancestorHandle);
      });
    }

    function removeDescendantSelections(handle) {
      var descendants = getDescendants(handle);

      descendants.forEach(function (descHandle) {
        removeExplicit(descHandle);
      });
    }

    function clearAllSelections() {
      if (state.explicit.size === 0) {
        return;
      }

      Array.from(state.explicit).forEach(function (handle) {
        removeExplicit(handle);
      });

      state.lastSelectionHandle = null;
    }

    function computeRootHandles() {
      var roots = new Set();

      state.explicit.forEach(function (handle) {
        if (isNonCategoryHandle(handle)) {
          return;
        }

        var node = state.nodes.get(handle);
        if (!node || !node.path || node.path.length === 0) {
          return;
        }
        roots.add(node.path[0]);
      });

      return roots;
    }

    function computeCombinedPaths() {
      var combined = [];
      var seen = new Set();
      var drillPath = Array.isArray(state.drillPath) ? state.drillPath.slice() : [];

      if (drillPath.length > 0) {
        var drillKey = drillPath.join('>');
        var drillHasExplicitDescendant = false;

        state.explicit.forEach(function (handle) {
          if (drillHasExplicitDescendant) {
            return;
          }

          var node = state.nodes.get(handle);
          if (!node || node.path.length <= drillPath.length) {
            return;
          }

          var matches = true;
          for (var i = 0; i < drillPath.length; i += 1) {
            if (node.path[i] !== drillPath[i]) {
              matches = false;
              break;
            }
          }

          if (matches && node.path.length > drillPath.length) {
            drillHasExplicitDescendant = true;
          }
        });

        if (!drillHasExplicitDescendant && !seen.has(drillKey)) {
          combined.push(drillPath);
          seen.add(drillKey);
        }
      }

      var explicitNodes = [];

      state.explicit.forEach(function (handle) {
        var node = state.nodes.get(handle);
        if (node) {
          explicitNodes.push(node);
        }
      });

      explicitNodes.forEach(function (node) {
        var hasExplicitDescendant = explicitNodes.some(function (candidate) {
          if (candidate === node) {
            return false;
          }

          if (!Array.isArray(candidate.path) || candidate.path.length <= node.path.length) {
            return false;
          }

          for (var i = 0; i < node.path.length; i += 1) {
            if (candidate.path[i] !== node.path[i]) {
              return false;
            }
          }

          return true;
        });

        if (hasExplicitDescendant) {
          return;
        }

        var key = node.path.join('>');
        if (seen.has(key)) {
          return;
        }

        combined.push(node.path.slice());
        seen.add(key);
      });

      return combined;
    }

    function computeFilterHandles() {
      var handles = new Set();

      computeCombinedPaths().forEach(function (path) {
        path.forEach(function (handle) {
          handles.add(handle);
        });
      });

      return handles;
    }

    function parseCategoryFilterParamFromUrl() {
      if (typeof window === 'undefined' || !window.location) {
        return [];
      }

      var value;

      try {
        var url = new URL(window.location.href);
        value = url.searchParams.get('category_filter');
      } catch (error) {
        return [];
      }

      if (!value) {
        return [];
      }

      return splitFilterParam(value)
        .map(function (group) {
          return group
            .split('_')
            .map(function (segment) {
              var normalized = toHandle(segment).trim();
              return normalized;
            })
            .filter(function (segment) {
              return segment.length > 0;
            });
        })
        .filter(function (segments) {
          return Array.isArray(segments) && segments.length > 0;
        });
    }

    function parseVariantFilterParamFromUrl() {
      if (typeof window === 'undefined' || !window.location) {
        return [];
      }

      var value;

      try {
        var url = new URL(window.location.href);
        value = url.searchParams.get('variant_filter');
      } catch (error) {
        return [];
      }

      if (!value) {
        return [];
      }

      return splitFilterParam(value)
        .map(function (segment) {
          var normalized = toHandle(segment).trim().replace(/_/g, '-');
          if (!normalized) {
            return '';
          }
          return normalized;
        })
        .filter(function (segment) {
          return segment.length > 0;
        });
    }

    function parseCustomFilterParamFromUrl() {
      if (typeof window === 'undefined' || !window.location) {
        return [];
      }

      var value;

      try {
        var url = new URL(window.location.href);
        value = url.searchParams.get('custom_filter');
      } catch (error) {
        return [];
      }

      if (!value) {
        return [];
      }

      return splitFilterParam(value)
        .map(function (segment) {
          var normalized = toHandle(segment).trim();
          return normalized;
        })
        .filter(function (segment) {
          return segment.length > 0;
        });
    }

    function findNodeByUrlSegment(segment, parentHandle) {
      var normalizedSegment = toHandle(segment).trim();
      if (!normalizedSegment) {
        return null;
      }

      var lowered = normalizedSegment.toLowerCase();
      var candidates = [];

      if (parentHandle) {
        var parentNode = state.nodes.get(parentHandle);
        if (!parentNode || !Array.isArray(parentNode.children) || parentNode.children.length === 0) {
          return null;
        }

        parentNode.children.forEach(function (childHandle) {
          var childNode = state.nodes.get(childHandle);
          if (childNode) {
            candidates.push(childNode);
          }
        });
      } else {
        state.rootHandles.forEach(function (rootHandle) {
          var rootNode = state.nodes.get(rootHandle);
          if (rootNode) {
            candidates.push(rootNode);
          }
        });
      }

      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        var token = getUrlHandleTokenFromNode(candidate);

        if (token && token.toLowerCase() === lowered) {
          return candidate;
        }
      }

      return null;
    }

    function resolvePathSegments(segments) {
      if (!Array.isArray(segments) || segments.length === 0) {
        return [];
      }

      var resolved = [];
      var parentHandle = null;

      for (var i = 0; i < segments.length; i += 1) {
        var rawSegment = segments[i];
        if (rawSegment === null || rawSegment === undefined) {
          return [];
        }

        var normalized = toHandle(rawSegment).trim();
        if (!normalized) {
          return [];
        }

        var node = findNodeByUrlSegment(normalized, parentHandle);

        if (!node) {
          return [];
        }

        if (parentHandle && node.parent !== parentHandle) {
          return [];
        }

        resolved.push(node.handle);
        parentHandle = node.handle;
      }

      return resolved;
    }

    function applySelectionPaths(paths, options) {
      options = options || {};
      var notify = options.notify !== false;
      var source = options.source || null;
      var resolvedPaths = [];
      var seen = new Set();

      (Array.isArray(paths) ? paths : []).forEach(function (segments) {
        var resolved = resolvePathSegments(segments);
        if (resolved.length === 0) {
          return;
        }

        var key = resolved.join('>');
        if (seen.has(key)) {
          return;
        }

        seen.add(key);
        resolvedPaths.push(resolved);
      });

      if (resolvedPaths.length === 0) {
        var hadSelection = state.explicit.size > 0 || state.drillPath.length > 0;
        state.drillPath = [];
        clearAllSelections();
        if (notify && hadSelection) {
          notifySelectionChange(source);
        } else {
          syncUrlParam();
        }
        return;
      }

      if (resolvedPaths.length === 1) {
        var singlePath = resolvedPaths[0].slice();
        var leafHandle = singlePath[singlePath.length - 1];

        state.drillPath = singlePath;
        replaceSelections([leafHandle], { deferNotify: true });
        state.lastSelectionHandle = leafHandle;

        if (notify) {
          notifySelectionChange(source);
        } else {
          syncUrlParam();
        }
        return;
      }

      var handles = resolvedPaths.map(function (path) {
        return path[path.length - 1];
      });

      state.drillPath = [];
      replaceSelections(handles, { deferNotify: true });
      state.lastSelectionHandle = handles.length ? handles[handles.length - 1] : null;

      if (notify) {
        notifySelectionChange(source);
      } else {
        syncUrlParam();
      }
    }

    function buildCategoryFilterParamString() {
      var combined = computeCombinedPaths();
      var entries = [];
      var seen = new Set();

      combined.forEach(function (path) {
        if (!Array.isArray(path) || path.length === 0) {
          return;
        }

        if (isVariantScentPath(path)) {
          return;
        }

        var handles = path.map(function (handle) {
          return getUrlHandleToken(handle);
        });
        var key = handles.join('>');

        if (seen.has(key)) {
          return;
        }

        seen.add(key);
        entries.push({
          handles: handles,
          group: handles.join('_'),
        });
      });

      if (!entries.length) {
        return null;
      }

      var filtered = entries.filter(function (entry) {
        return !entries.some(function (other) {
          if (other === entry) {
            return false;
          }

          if (!Array.isArray(other.handles) || other.handles.length <= entry.handles.length) {
            return false;
          }

          for (var i = 0; i < entry.handles.length; i += 1) {
            if (other.handles[i] !== entry.handles[i]) {
              return false;
            }
          }

          return true;
        });
      });

      if (!filtered.length) {
        return null;
      }

      return filtered
        .map(function (entry) {
          return entry.group;
        })
        .join(FILTER_PARAM_SEPARATOR);
    }

    function buildVariantFilterParamString() {
      var handles = [];

      state.explicit.forEach(function (handle) {
        if (isVariantScentHandle(handle)) {
          handles.push(handle);
        }
      });

      if (!handles.length) {
        return null;
      }

      return handles.join(FILTER_PARAM_SEPARATOR);
    }

    function buildCustomFilterParamString() {
      var handles = [];

      state.explicit.forEach(function (handle) {
        if (isCustomSidebarHandle(handle)) {
          handles.push(handle);
        }
      });

      if (!handles.length) {
        return null;
      }

      return handles.join(FILTER_PARAM_SEPARATOR);
    }

    function syncUrlParam() {
      if (typeof window === 'undefined' || !window.history || !window.location) {
        return;
      }

      var categoryValue = buildCategoryFilterParamString();
      var variantValue = buildVariantFilterParamString();
      var customValue = buildCustomFilterParamString();
      var url;

      try {
        url = new URL(window.location.href);
      } catch (error) {
        return;
      }

      var facetValues = {
        category_filter: categoryValue,
        variant_filter: variantValue,
        custom_filter: customValue,
      };

      var preservedParams = [];

      url.searchParams.forEach(function (value, key) {
        if (FILTER_PARAM_ORDER.indexOf(key) === -1) {
          preservedParams.push([key, value]);
        }
      });

      var nextParams = new URLSearchParams();

      FILTER_PARAM_ORDER.forEach(function (key) {
        var value = facetValues[key];
        if (value && value.length) {
          nextParams.append(key, value);
        }
      });

      preservedParams.forEach(function (entry) {
        nextParams.append(entry[0], entry[1]);
      });

      url.search = nextParams.toString().replace(/%2B/gi, '+');
      window.history.replaceState(null, '', url.toString());
      updateCanonicalUrl();
    }

    function applyUrlFilters(options) {
      options = options || {};

      if (state.urlApplied && !options.force) {
        return;
      }

      var paths = parseCategoryFilterParamFromUrl();
      var variantHandles = parseVariantFilterParamFromUrl();
      var customHandles = parseCustomFilterParamFromUrl();

      if (Array.isArray(variantHandles) && variantHandles.length) {
        variantHandles.forEach(function (handle) {
          if (!handle) {
            return;
          }
          paths.push([handle]);
        });
      }

      if (Array.isArray(customHandles) && customHandles.length) {
        customHandles.forEach(function (handle) {
          if (!handle) {
            return;
          }
          paths.push([handle]);
        });
      }

      state.urlApplied = true;

      if (!paths.length) {
        applySelectionPaths([], { notify: options.notify !== false, source: options.source || 'url' });
        return;
      }

      applySelectionPaths(paths, { notify: options.notify !== false, source: options.source || 'url' });
    }

    function buildTagList() {
      var order = 0;
      var lookup = new Map();

      computeCombinedPaths().forEach(function (path) {
        (Array.isArray(path) ? path : []).forEach(function (handle) {
          if (lookup.has(handle)) {
            return;
          }

          var node = state.nodes.get(handle);
          if (!node) {
            return;
          }

          lookup.set(handle, {
            handle: node.handle,
            name: node.name,
            depth: node.depth,
            order: order++,
          });
        });
      });

      return Array.from(lookup.values()).sort(function (a, b) {
        if (a.depth !== b.depth) {
          return b.depth - a.depth;
        }
        return a.order - b.order;
      });
    }

    function alignDrillPath() {
      if (!state.drillPath.length) {
        return false;
      }

      var trimmed = [];

      for (var i = 0; i < state.drillPath.length; i += 1) {
        var handle = state.drillPath[i];
        var node = state.nodes.get(handle);

        if (!node) {
          break;
        }

        if (!hasDerived(handle)) {
          break;
        }

        trimmed.push(handle);
      }

      if (trimmed.length === state.drillPath.length) {
        return false;
      }

      state.drillPath = trimmed;
      return true;
    }

    function getPublicState(options) {
      options = options || {};
      var aggregateCounts = options.aggregateCounts !== false;

      var rootHandles = computeRootHandles();
      var activePaths = computeCombinedPaths();
      var selectionCount = aggregateCounts ? activePaths.length : state.explicit.size;
      var categorySelectionCount = countCategorySelections(activePaths);
      var multiSelection = categorySelectionCount > 1;

      return {
        initialized: state.initialized,
        tree: state.tree,
        explicit: new Set(state.explicit),
        derivedCounts: new Map(state.derivedCounts),
        checked: computeFilterHandles(),
        activePaths: activePaths,
        drillPath: state.drillPath.slice(),
        tags: buildTagList(),
        filterHandles: computeFilterHandles(),
        sidebarOpen: state.sidebarOpen,
        multiRoot: rootHandles.size > 1,
        multiSelection: multiSelection,
        selectionCount: selectionCount,
        explicitSelectionCount: state.explicit.size,
        categorySelectionCount: categorySelectionCount,
        rootHandles: rootHandles,
        lastSelection: state.lastSelectionHandle,
        getNode: getNode,
      };
    }

    function emit(eventType, payload) {
      var snapshot = getPublicState({ aggregateCounts: true });
      snapshot.rawSelectionCount = state.explicit.size;
      snapshot.event = eventType;
      snapshot.detail = payload || {};

      state.listeners.forEach(function (listener) {
        try {
          listener(snapshot);
        } catch (error) {
          console.warn('NativeCategoryFilter listener error', error);
        }
      });
    }

    function notifySelectionChange(source) {
      var changed = alignDrillPath();
      var rootHandles = computeRootHandles();
      var multiRoot = rootHandles.size > 1;
      var activePaths = computeCombinedPaths();
      var selectionCount = activePaths.length;
      var categorySelectionCount = countCategorySelections(activePaths);
      var multiSelection = categorySelectionCount > 1;
      var disableDrill = multiRoot || multiSelection || categorySelectionCount === 0;

      if (disableDrill) {
        if (state.drillPath.length > 0) {
          state.drillPath = [];
          changed = true;
        }
      } else if (categorySelectionCount > 0) {
        var selectedHandle = getLastCategorySelectionHandle();

        if (selectedHandle) {
          var node = state.nodes.get(selectedHandle);
          if (node && node.path.length > 0) {
            var nextPath = node.path.slice();
            var samePath =
              state.drillPath.length === nextPath.length &&
              state.drillPath.every(function (handle, index) {
                return handle === nextPath[index];
              });

            if (!samePath) {
              state.drillPath = nextPath;
              changed = true;
            }
          }
        }
      }

      state.multiRootCache = multiRoot;
      state.multiSelectionCache = multiSelection;

      emit('selection-changed', {
        source: source || null,
        drillPathChanged: changed,
        selectionCount: selectionCount,
        categorySelectionCount: categorySelectionCount,
      });
      syncUrlParam();
    }

    function init(data) {
      if (!data || !Array.isArray(data.filters)) {
        return;
      }

      if (state.initialized) {
        return;
      }

      buildTree(data.filters);
      state.initialized = true;

      applyUrlFilters({ source: 'url' });
      emit('init', {});
    }

    function ensureData(data) {
      if (!state.initialized && data && Array.isArray(data.filters)) {
        init(data);
      }
    }

    function selectHandle(handle, options) {
      options = options || {};
      var normalized = toHandle(handle);

      if (!addExplicit(normalized)) {
        return;
      }

      if (options.clearAncestorExplicit !== false) {
        clearExplicitAncestors(normalized);
      }

      if (options.removeDescendants) {
        removeDescendantSelections(normalized);
      }

      state.lastSelectionHandle = normalized;

      if (!options.deferNotify) {
        notifySelectionChange(options.source);
      }
    }

    function deselectHandle(handle, options) {
      options = options || {};
      var normalized = toHandle(handle);

      if (!removeExplicit(normalized)) {
        return;
      }

      if (!options.deferNotify) {
        notifySelectionChange(options.source);
      }
    }

    function replaceSelections(handles, options) {
      options = options || {};
      var source = options.source;
      var next = new Set();
      var lastHandle = null;

      if (Array.isArray(handles)) {
        handles.forEach(function (handle) {
          var normalized = toHandle(handle);
          if (state.nodes.has(normalized)) {
            next.add(normalized);
            lastHandle = normalized;
          }
        });
      }

      var modified = false;

      Array.from(state.explicit).forEach(function (handle) {
        if (!next.has(handle)) {
          removeExplicit(handle);
          modified = true;
        }
      });

      next.forEach(function (handle) {
        if (!state.explicit.has(handle)) {
          addExplicit(handle);
          modified = true;
        }
      });

      if (next.size > 0) {
        if (lastHandle && next.has(lastHandle)) {
          state.lastSelectionHandle = lastHandle;
        } else {
          var iterator = next.values().next();
          if (!iterator.done) {
            state.lastSelectionHandle = iterator.value;
          }
        }
      } else {
        state.lastSelectionHandle = null;
      }

      if (modified && !options.deferNotify) {
        notifySelectionChange(source);
      }
    }

    function setDrillPath(path, options) {
      options = options || {};
      var nextPath = Array.isArray(path)
        ? path
            .map(function (value) {
              return toHandle(value);
            })
            .filter(function (handle) {
              return state.nodes.has(handle);
            })
        : [];

      state.drillPath = nextPath.slice();
      state.lastSelectionHandle = nextPath.length ? nextPath[nextPath.length - 1] : null;

      if (options.updateSelection !== false) {
        if (nextPath.length === 0) {
          replaceSelections([], { deferNotify: true });
        } else {
          var targetHandles = options.replaceSelections === false ? [nextPath[nextPath.length - 1]] : nextPath;
          replaceSelections(targetHandles, { deferNotify: true });
        }
      }

      notifySelectionChange(options.source);
    }

    function setSidebarOpen(isOpen, options) {
      var normalized = Boolean(isOpen);

      if (state.sidebarOpen === normalized) {
        return;
      }

      state.sidebarOpen = normalized;
      emit('ui-change', { source: options && options.source ? options.source : null });
    }

    function subscribe(callback, options) {
      if (typeof callback !== 'function') {
        return function () {};
      }

      state.listeners.add(callback);

      var opts = options || {};

      if (opts.immediate !== false) {
        callback(
          Object.assign(getPublicState(), {
            event: 'init',
            detail: {},
          })
        );
      }

      return function unsubscribe() {
        state.listeners.delete(callback);
      };
    }

    function handleCheckbox(handle, shouldSelect, options) {
      options = options || {};

      var normalized = toHandle(handle);
      if (!state.nodes.has(normalized)) {
        return;
      }

      if (shouldSelect) {
        selectHandle(normalized, {
          source: options.source,
          removeDescendants: options.removeDescendants !== false,
          clearAncestorExplicit: options.clearAncestorExplicit !== false,
        });
        return;
      }

      var notifySource = options.source;
      var didChange = false;

      if (state.explicit.has(normalized)) {
        deselectHandle(normalized, { source: notifySource, deferNotify: true });
        didChange = true;
      }

      var beforeSize = state.explicit.size;
      removeDescendantSelections(normalized);
      if (state.explicit.size !== beforeSize) {
        didChange = true;
      }

      if (didChange) {
        notifySelectionChange(notifySource);
      }
    }

    function clearAll(source) {
      clearAllSelections();
      notifySelectionChange(source);
    }

    function getNode(handle) {
      return state.nodes.get(toHandle(handle)) || null;
    }

    function getNodeById(id) {
      var key = toHandle(id);
      if (!key || !state.nodesById.has(key)) {
        return null;
      }

      var handle = state.nodesById.get(key);
      return handle ? state.nodes.get(handle) || null : null;
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', function () {
        if (!state.initialized) {
          return;
        }

        applyUrlFilters({ source: 'history', force: true });
      });
    }

    window.NativeCategoryFilter = {
      init: init,
      ensureData: ensureData,
      subscribe: subscribe,
      getState: getPublicState,
      selectHandle: selectHandle,
      deselectHandle: deselectHandle,
      replaceSelections: replaceSelections,
      handleCheckbox: handleCheckbox,
      clearAll: clearAll,
      setDrillPath: setDrillPath,
      setSidebarOpen: setSidebarOpen,
      getNode: getNode,
      getNodeById: getNodeById,
      getAncestors: getAncestors,
      getDescendants: getDescendants,
      getFilterHandles: computeFilterHandles,
      applyUrlFilters: applyUrlFilters,
    };

    if (
      typeof window !== 'undefined' &&
      window.NativeFilterRegistry &&
      typeof window.NativeFilterRegistry.sync === 'function'
    ) {
      window.NativeFilterRegistry.sync();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-filter-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    try {
      var resultsObserver = null;

      function createSidebarDrawerSync() {
        var mediaQuery = window.matchMedia('(max-width: 1023px)');
        var originalParent = null;
        var originalNextSibling = null;

        function captureOriginal(sidebar) {
          if (!sidebar) {
            return;
          }

          if (sidebar.dataset.sidebarFilterMobile === 'true') {
            return;
          }

          if (!originalParent || !originalParent.isConnected || originalParent === sidebar.parentNode) {
            originalParent = sidebar.parentNode;
            originalNextSibling = sidebar.nextElementSibling;
          }
        }

        function ensurePlaceholder(target) {
          if (!target) {
            return;
          }

          if (!target.querySelector('[data-sidebar-filter-mobile-placeholder]')) {
            var placeholder = document.createElement('div');
            placeholder.className = 'filter-drawer__sidebar-placeholder';
            placeholder.setAttribute('data-sidebar-filter-mobile-placeholder', 'true');
            var defaultMessage = target.getAttribute('data-sidebar-placeholder') || 'Loading filters...';
            placeholder.textContent = defaultMessage;
            target.appendChild(placeholder);
          }
        }

        function extractResultsCount() {
          var resultsCountEl = document.querySelector('[data-filter-topbar] [data-results-count]');

          if (!resultsCountEl) {
            return null;
          }

          var text = resultsCountEl.textContent || '';
          var matches = text.match(/\d[\d,.\s]*/g);

          if (!matches || matches.length === 0) {
            return null;
          }

          var raw = matches[matches.length - 1].replace(/[^\d]/g, '');
          return raw || null;
        }

        function updateApplyButtonCount() {
          var drawer = document.querySelector('[data-filter-drawer]');
          if (!drawer) {
            return;
          }

          var applyCountEl = drawer.querySelector('.filter-drawer__apply-count');
          if (!applyCountEl) {
            return;
          }

          var count = extractResultsCount();

          if (count === null) {
            return;
          }

          applyCountEl.textContent = '('.concat(count, ')');
        }

        function watchResultsCount() {
          var resultsCountEl = document.querySelector('[data-filter-topbar] [data-results-count]');

          if (!resultsCountEl) {
            if (resultsObserver) {
              resultsObserver.disconnect();
              resultsObserver = null;
            }
            return;
          }

          updateApplyButtonCount();

          if (resultsObserver) {
            resultsObserver.disconnect();
          }

          resultsObserver = new MutationObserver(function () {
            updateApplyButtonCount();
          });

          resultsObserver.observe(resultsCountEl, {
            characterData: true,
            subtree: true,
            childList: true,
          });
        }

        function moveSidebar() {
          var sidebar = document.querySelector('[data-filter-sidebar]');
          var drawer = document.querySelector('[data-filter-drawer]');
          var target = drawer ? drawer.querySelector('[data-sidebar-filter-mobile-target]') : null;

          if (!sidebar) {
            watchResultsCount();
            return;
          }

          captureOriginal(sidebar);

          if (!mediaQuery.matches) {
            if (sidebar.dataset.sidebarFilterMobile === 'true') {
              if (originalParent && originalParent.isConnected) {
                if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
                  originalParent.insertBefore(sidebar, originalNextSibling);
                } else {
                  originalParent.appendChild(sidebar);
                }
              }

              sidebar.removeAttribute('data-sidebar-filter-mobile');
            }

            if (target) {
              ensurePlaceholder(target);
            }

            watchResultsCount();

            return;
          }

          if (!target) {
            watchResultsCount();
            return;
          }

          var placeholder = target.querySelector('[data-sidebar-filter-mobile-placeholder]');

          if (!target.contains(sidebar)) {
            if (placeholder) {
              placeholder.remove();
            }

            target.appendChild(sidebar);
          }

          sidebar.setAttribute('data-sidebar-filter-mobile', 'true');
          watchResultsCount();
        }

        var handleFiltersRender = function handleFiltersRender() {
          window.requestAnimationFrame(moveSidebar);
          window.requestAnimationFrame(watchResultsCount);
        };

        if (typeof mediaQuery.addEventListener === 'function') {
          mediaQuery.addEventListener('change', moveSidebar);
        } else if (typeof mediaQuery.addListener === 'function') {
          mediaQuery.addListener(moveSidebar);
        }

        document.addEventListener('filters:render-filters', handleFiltersRender);
        document.addEventListener('shopify:section:load', moveSidebar);
        document.addEventListener('collection:updated', handleFiltersRender);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', moveSidebar);
        } else {
          moveSidebar();
        }

        return {
          sync: moveSidebar,
        };
      }

      if (!window.SidebarDrawerSync) {
        window.SidebarDrawerSync = createSidebarDrawerSync();
      } else if (window.SidebarDrawerSync && typeof window.SidebarDrawerSync.sync === 'function') {
        window.SidebarDrawerSync.sync();
      }
    } catch (error) {
      console.warn('Custom filter drawer: unable to initialise mobile sidebar.', error);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-horizontal-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    var registry = window.NativeFilterRegistry || {};
    var filterData = {
      filters: Array.isArray(window.NativeCategoryFiltersPayload)
        ? window.NativeCategoryFiltersPayload
        : Array.isArray(registry.categoryFilters)
        ? registry.categoryFilters
        : [],
    };

    if (!window.NativeCategoryFilter) {
      console.warn('Horizontal filter: NativeCategoryFilter is not available.');
      return;
    }

    var state = NativeCategoryFilter.getState();
    var wrapper = document.querySelector('.collection-banner__horizontal-filter-wrapper');
    var filterList = document.getElementById('filterList');
    var tagsContainer = document.getElementById('selectedTags');
    var scrollRoot = document.querySelector('[data-horizontal-scroll-root]');
    var scrollTarget = document.querySelector('.horizontal-filter-scroll');
    var stringsHost = document.querySelector('[data-horizontal-filter-strings]');

    var noResultsStrings = {
      heading: stringsHost ? stringsHost.getAttribute('data-no-results-heading') || '' : '',
      useFewer: stringsHost ? stringsHost.getAttribute('data-no-results-use-fewer') || '' : '',
      clearAll: stringsHost ? stringsHost.getAttribute('data-no-results-clear-all') || '' : '',
    };

    if (!noResultsStrings.heading) {
      noResultsStrings.heading = 'No products found';
    }
    if (!noResultsStrings.useFewer) {
      noResultsStrings.useFewer = 'Try fewer filters';
    }
    if (!noResultsStrings.clearAll) {
      noResultsStrings.clearAll = 'Clear all';
    }

    var collectionSection = null;
    var productsHolder = null;
    var productItems = [];
    var noResultsContainer = null;
    var lastAppliedKey = null;

    var breadcrumbState = (function () {
      var ctx = getBreadcrumbContext();
      return {
        captured: !!ctx,
        originalHTML: ctx ? ctx.li.innerHTML : '',
        baseHidden: ctx && ctx.sep ? ctx.sep.classList.contains('tw:hidden') : false,
      };
    })();

    var headingEl =
      document.getElementById('collection-heading') ||
      document.querySelector('.collection-banner__text-container-heading');
    var dynamicTitleEnabled = headingEl ? headingEl.getAttribute('data-dynamic-title') === 'true' : false;
    var originalDocumentTitle = document.title || '';
    var documentTitleSuffix = deriveDocumentTitleSuffix(originalDocumentTitle);
    var documentTitleBase = deriveDocumentTitleBase(originalDocumentTitle);

    if (headingEl && !headingEl.dataset.originalTitle) {
      headingEl.dataset.originalTitle = (headingEl.textContent || '').trim();
    }

    var multiRootTitle = 'Shop the Essentials';
    var COLLECTION_TITLE_SEPARATOR = ' / ';
    var variantHandleCache = new Map();

    function normalizeHandle(handle) {
      return (handle || '').toString().trim().toLowerCase();
    }

    function normalizeVariantHandle(handle) {
      return (handle || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-');
    }

    function stripVariantHandles(path) {
      if (!Array.isArray(path)) {
        return [];
      }

      return path.filter(function (handle) {
        return !isVariantHandle(handle) && !isCustomSidebarHandle(handle);
      });
    }

    function deriveDocumentTitleBase(baseTitle) {
      if (!baseTitle) {
        return '';
      }

      var parts = baseTitle.split('|');
      if (parts.length > 1) {
        return parts[0].trim();
      }

      return baseTitle.trim();
    }

    function deriveDocumentTitleSuffix(baseTitle) {
      if (!baseTitle) {
        return '';
      }

      var parts = baseTitle.split('|');
      if (parts.length > 1) {
        return ' | ' + parts.slice(1).join('|').trim();
      }

      return '';
    }

    function getCategoryPaths(snapshot) {
      var paths = Array.isArray(snapshot && snapshot.activePaths) ? snapshot.activePaths : [];
      var categoryPaths = [];

      paths.forEach(function (path) {
        if (!Array.isArray(path) || path.length === 0) {
          return;
        }

        var filtered = path.filter(function (handle) {
          return !isVariantHandle(handle) && !isCustomSidebarHandle(handle);
        });

        if (filtered.length > 0) {
          categoryPaths.push(filtered);
        }
      });

      return categoryPaths;
    }

    function deriveCategoryHeading(categoryPaths) {
      if (!Array.isArray(categoryPaths) || categoryPaths.length === 0) {
        return null;
      }

      var rootHandles = categoryPaths
        .map(function (path) {
          return Array.isArray(path) && path.length ? path[0] : null;
        })
        .filter(Boolean);

      var uniqueRoots = new Set(rootHandles);

      if (uniqueRoots.size > 1) {
        return multiRootTitle;
      }

      if (categoryPaths.length > 1) {
        var sharedRoot = rootHandles[0];
        var rootOption = resolveHandleToOption(sharedRoot);
        return rootOption && rootOption.name ? rootOption.name : null;
      }

      var path = categoryPaths[0];
      var parts = path
        .slice()
        .map(function (handle) {
          var option = resolveHandleToOption(handle);
          return option ? option.name : null;
        })
        .filter(Boolean);

      if (!parts.length) {
        return null;
      }

      return parts.join(' ');
    }

    function updateMetadata(snapshot) {
      var categoryPaths = getCategoryPaths(snapshot);
      var headingText = deriveCategoryHeading(categoryPaths);

      var nextTitle;
      if (headingText) {
        var base = headingText === multiRootTitle ? '' : documentTitleBase || '';
        nextTitle = (base ? base + ' ' : '') + headingText + (documentTitleSuffix || '');
      } else {
        nextTitle = originalDocumentTitle;
      }

      if (nextTitle && nextTitle !== document.title) {
        document.title = nextTitle;

        var ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) {
          ogTitle.setAttribute('content', nextTitle);
        }

        var twitterTitle = document.querySelector('meta[name="twitter:title"]');
        if (twitterTitle) {
          twitterTitle.setAttribute('content', nextTitle);
        }
      }
    }

    function updateOverflowState() {
      if (!scrollRoot || !scrollTarget) {
        return;
      }

      var hasOverflow = scrollTarget.scrollWidth > scrollTarget.clientWidth + 1;
      scrollRoot.setAttribute('data-scroll-has-overflow', hasOverflow ? 'true' : 'false');
    }

    function getActiveDrillPath(snapshot) {
      var path = snapshot && Array.isArray(snapshot.drillPath) ? snapshot.drillPath.slice() : [];

      if (
        (!path || path.length === 0) &&
        snapshot &&
        Array.isArray(snapshot.activePaths) &&
        snapshot.activePaths.length === 1
      ) {
        path = snapshot.activePaths[0].slice();
      }

      path = stripVariantHandles(path);

      return Array.isArray(path) ? path : [];
    }

    if (filterList) {
      filterList.addEventListener('click', onFilterListClick);
    }

    if (scrollTarget) {
      scrollTarget.addEventListener('scroll', updateOverflowState, { passive: true });
    }

    if (tagsContainer) {
      tagsContainer.addEventListener('click', onTagClick);
    }

    var unsubscribe = NativeCategoryFilter.subscribe(onStateChange);

    monitorSidebarVisibility();
    attachSidebarToggleListeners();
    ensureProductContext();
    cacheProductItems();
    applyProductFilters({ dispatch: false });

    document.addEventListener('collection:updated', onCollectionUpdated);
    onStateChange(state);
    updateOverflowState();

    window.addEventListener('unload', function () {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    });

    function onStateChange(snapshot) {
      state = snapshot;
      renderTags(snapshot);
      renderFilterList(snapshot);
      updateBreadcrumbs(snapshot);
      updateHeading(snapshot);
      updateMetadata(snapshot);
      updateVisibility(snapshot);
      updateFilterCounts(snapshot);
      applyProductFilters({ force: true });
      updateOverflowState();
    }

    function onFilterListClick(event) {
      var target = event.target.closest('.horizontal-filter-item');

      if (!target || !filterList.contains(target)) {
        return;
      }

      var action = target.dataset.action || '';

      if (action === 'all') {
        var currentPath = getActiveDrillPath(state);
        var context = getListContext(state);

        if (context.mode === 'siblings' && currentPath.length > 0) {
          NativeCategoryFilter.setDrillPath(currentPath.slice(0, -1), {
            source: 'horizontal',
            replaceSelections: true,
          });
        } else if (context.mode === 'root' && currentPath.length > 0) {
          NativeCategoryFilter.setDrillPath([], {
            source: 'horizontal',
            replaceSelections: true,
          });
        } else {
          NativeCategoryFilter.setDrillPath(currentPath, {
            source: 'horizontal',
            replaceSelections: true,
          });
        }
        return;
      }

      var handle = target.dataset.handle;
      if (!handle) {
        return;
      }

      var option = resolveHandleToOption(handle);
      if (!option) {
        return;
      }

      var path = getActiveDrillPath(state);
      var existingIndex = path.indexOf(handle);

      if (existingIndex > -1) {
        NativeCategoryFilter.setDrillPath(path.slice(0, existingIndex + 1), {
          source: 'horizontal',
          replaceSelections: true,
        });
        return;
      }

      var context = getListContext(state);
      var nextPath;

      if (context.mode === 'siblings' && path.length > 0) {
        nextPath = path.slice(0, path.length - 1).concat(handle);
      } else {
        nextPath = path.concat(handle);
      }

      var isRootNode = option.node && option.node.depth === 0 && !isVariantHandle(option.handle);

      if (isRootNode) {
        NativeCategoryFilter.replaceSelections([option.handle], {
          source: 'horizontal-root',
        });

        NativeCategoryFilter.setDrillPath([option.handle], {
          source: 'horizontal',
          replaceSelections: false,
        });

        return;
      }

      NativeCategoryFilter.setDrillPath(nextPath, {
        source: 'horizontal',
        replaceSelections: true,
      });
    }

    function onTagClick(event) {
      if (!tagsContainer) {
        return;
      }

      var button = event.target.closest('[data-tag-remove]');

      if (!button || !tagsContainer.contains(button)) {
        return;
      }

      var index = parseInt(button.dataset.index, 10);
      if (isNaN(index)) {
        return;
      }

      var path = getActiveDrillPath(state);

      if (index < 0 || index > path.length) {
        return;
      }

      var nextPath = path.slice(0, index);

      NativeCategoryFilter.setDrillPath(nextPath, {
        source: 'horizontal',
        replaceSelections: true,
      });
    }

    function renderTags(snapshot) {
      if (!tagsContainer) {
        return;
      }

      tagsContainer.innerHTML = '';

      var path = getActiveDrillPath(snapshot);

      if (!path.length) {
        tagsContainer.classList.add('tw:hidden');
        tagsContainer.style.width = '0px';
        return;
      }

      path.forEach(function (handle, index) {
        var option = resolveHandleToOption(handle);
        if (!option) {
          return;
        }

        var tag = document.createElement('div');
        tag.className = 'selected-tag';
        tag.dataset.index = String(index);

        var text = document.createElement('span');
        text.className = 'tag-text';
        text.textContent = option.name;

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'close';
        close.setAttribute('data-tag-remove', '');
        close.dataset.index = String(index);
        close.innerHTML =
          '<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g opacity="0.5">' +
          '<path d="M11.25 4.25L3.75 11.75" stroke="#0E1029" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '<path d="M3.75 4.25L11.25 11.75" stroke="#0E1029" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '</g>' +
          '</svg>';

        tag.appendChild(text);
        tag.appendChild(close);
        tagsContainer.appendChild(tag);
      });

      tagsContainer.classList.remove('tw:hidden');
      requestAnimationFrame(updateTagPositions);
    }

    function updateTagPositions() {
      if (!tagsContainer) {
        return;
      }

      var tags = Array.from(tagsContainer.querySelectorAll('.selected-tag:not(.removing)'));

      if (!tags.length) {
        tagsContainer.classList.add('tw:hidden');
        tagsContainer.style.width = '0px';
        return;
      }

      var offset = 0;
      var stackOffset = 11;

      tags.forEach(function (tag, index) {
        var zIndex = index + 1;
        tag.style.zIndex = zIndex;
        tag.style.left = offset + 'px';

        if (index < tags.length - 1) {
          tag.classList.add('stacked');
          offset += stackOffset;
        } else {
          tag.classList.remove('stacked');
          offset += tag.offsetWidth || 0;
        }
      });

      tagsContainer.style.width = offset + 'px';
    }

    function renderFilterList(snapshot) {
      if (!filterList) {
        return;
      }

      var context = getListContext(snapshot);

      filterList.innerHTML = '';

      var allItem = document.createElement('li');
      allItem.className = 'horizontal-filter-item';
      allItem.style.fontFamily = "'BrandonGrotesque', sans-serif !important";
      allItem.dataset.action = 'all';
      allItem.textContent = 'All';

      var allActive =
        !snapshot ||
        !snapshot.drillPath.length ||
        context.mode === 'children' ||
        (context.mode === 'siblings' && !context.activeHandle);

      if (allActive) {
        allItem.classList.add('active');
      }

      filterList.appendChild(allItem);

      context.nodes.forEach(function (option) {
        var li = document.createElement('li');
        li.className = 'horizontal-filter-item';
        li.style.fontFamily = "'BrandonGrotesque', sans-serif !important";
        li.dataset.handle = option.handle;
        li.textContent = option.name;

        if (context.activeHandle && context.activeHandle === option.handle) {
          li.classList.add('active');
        }

        filterList.appendChild(li);
      });

      updateOverflowState();
    }

    function updateBreadcrumbs(snapshot) {
      var ctx = getBreadcrumbContext();
      if (!ctx) {
        return;
      }

      if (!dynamicTitleEnabled) {
        return;
      }

      if (!breadcrumbState.captured) {
        breadcrumbState.originalHTML = ctx.li.innerHTML;
        breadcrumbState.baseHidden = ctx.sep ? ctx.sep.classList.contains('tw:hidden') : false;
        breadcrumbState.captured = true;
      }

      ctx.li.innerHTML = breadcrumbState.originalHTML;

      ctx = getBreadcrumbContext();
      if (!ctx) {
        return;
      }

      var li = ctx.li;
      var sep = ctx.sep;
      var shouldReset = !snapshot || snapshot.multiRoot || snapshot.multiSelection || !snapshot.drillPath.length;

      if (sep) {
        if (shouldReset) {
          if (breadcrumbState.baseHidden) {
            sep.classList.add('tw:hidden');
          } else {
            sep.classList.remove('tw:hidden');
          }
        } else {
          sep.classList.remove('tw:hidden');
        }
      }

      if (shouldReset) {
        return;
      }

      var appendedCount = 0;

      snapshot.drillPath.forEach(function (handle) {
        var option = resolveHandleToOption(handle);
        if (!option) {
          return;
        }

        var wrapper = document.createElement('span');
        wrapper.className = 'js-bc-extra breadcrumb-added breadcrumb__item tw:gap-2';
        wrapper.style.display = 'flex';
        wrapper.style.alignItems = 'center';

        if (sep && appendedCount > 0) {
          var clone = sep.cloneNode(true);
          clone.classList.remove('tw:hidden');
          wrapper.appendChild(clone);
        }

        var label = document.createElement('span');
        label.className = 'breadcrumb__text';
        label.textContent = option.name;
        wrapper.appendChild(label);

        li.appendChild(wrapper);
        appendedCount += 1;
      });
    }

    function updateHeading(snapshot) {
      if (!headingEl) {
        return;
      }

      var nextTitle = headingEl.dataset.originalTitle || headingEl.textContent || '';

      if (!dynamicTitleEnabled) {
        headingEl.textContent = nextTitle;
        return;
      }

      if (!snapshot || snapshot.selectionCount === 0) {
        nextTitle = headingEl.dataset.originalTitle || nextTitle;
      } else if (snapshot.multiRoot || snapshot.multiSelection) {
        nextTitle = multiRootTitle;
      } else if (snapshot && snapshot.drillPath.length) {
        var names = snapshot.drillPath
          .slice()
          .map(function (handle) {
            var option = resolveHandleToOption(handle);
            return option ? option.name : null;
          })
          .filter(Boolean);

        if (names.length) {
          nextTitle = names.join(COLLECTION_TITLE_SEPARATOR);
        }
      }

      headingEl.textContent = nextTitle;
    }

    function updateVisibility(snapshot) {
      if (!wrapper) {
        return;
      }

      var shouldHide = !snapshot || snapshot.multiRoot || snapshot.sidebarOpen || snapshot.multiSelection;
      wrapper.style.display = shouldHide ? 'none' : '';
    }

    function updateFilterCounts(snapshot) {
      var count = snapshot && typeof snapshot.selectionCount === 'number' ? snapshot.selectionCount : 0;
      var hasActiveFilters = count > 0;
      var display = '('.concat(count, ')');
      var targets = document.querySelectorAll('[data-filter-count]');

      targets.forEach(function (element) {
        element.textContent = display;

        if (element.hasAttribute('data-has-active-filters')) {
          element.setAttribute('data-has-active-filters', hasActiveFilters ? 'true' : 'false');
        }

        if (element.dataset && element.dataset.filterCount === 'drawer-title') {
          if (hasActiveFilters) {
            element.removeAttribute('hidden');
          } else {
            element.setAttribute('hidden', '');
          }
        }
      });

      var drawer = document.querySelector('[data-filter-drawer]');

      if (drawer) {
        drawer.setAttribute('data-filters-active', hasActiveFilters ? 'true' : 'false');
      }
    }

    function getMatchPaths(snapshot) {
      if (!snapshot) {
        return [];
      }

      var paths = Array.isArray(snapshot.activePaths) ? snapshot.activePaths : [];

      return paths
        .map(function (path) {
          return Array.isArray(path)
            ? path
                .map(function (handle) {
                  return normalizeHandle(handle);
                })
                .filter(function (value) {
                  return value.length > 0;
                })
            : [];
        })
        .filter(function (path) {
          return path.length > 0;
        });
    }

    function getHandleTokens(handle) {
      var tokens = [];
      var normalizedHandle = normalizeHandle(handle);
      if (normalizedHandle) {
        tokens.push(normalizedHandle);
      }

      var node = getFilterNode(handle);
      if (node && node.data) {
        var idToken = normalizeHandle(node.data.id);
        if (idToken && tokens.indexOf(idToken) === -1) {
          tokens.push(idToken);
        }

        var metaToken = normalizeHandle(node.data.metaobject_handle);
        if (metaToken && tokens.indexOf(metaToken) === -1) {
          tokens.push(metaToken);
        }
      }

      return tokens;
    }

    function applyProductFilters(options) {
      options = options || {};
      ensureProductContext();

      if (!productsHolder) {
        return;
      }

      if (!productItems.length || options.refresh === true) {
        cacheProductItems();
      }

      var matchPaths = getMatchPaths(state);
      var categoryPaths = [];
      var variantHandles = [];
      var customHandles = [];
      var variantSeen = new Set();
      var customSeen = new Set();

      matchPaths.forEach(function (path) {
        if (!Array.isArray(path) || path.length === 0) {
          return;
        }

        var last = path[path.length - 1];

        if (isVariantHandle(last)) {
          if (!variantSeen.has(last)) {
            variantSeen.add(last);
            variantHandles.push(last);
          }
          return;
        }

        if (isCustomSidebarHandle(last)) {
          if (!customSeen.has(last)) {
            customSeen.add(last);
            customHandles.push(last);
          }
          return;
        }

        categoryPaths.push(path);
      });

      var orderedVariantTokens = [];
      var orderedVariantTokenSet = new Set();

      // Preserve active selection order from filter state; cards use first matching token
      variantHandles.forEach(function (handle) {
        var token = getVariantHandleName(handle);
        if (!token || orderedVariantTokenSet.has(token)) {
          return;
        }

        orderedVariantTokenSet.add(token);
        orderedVariantTokens.push(token);
      });

      var hasFilters = categoryPaths.length > 0 || variantHandles.length > 0 || customHandles.length > 0;
      var handlesKey = !hasFilters
        ? '__all__'
        : categoryPaths
            .map(function (path) {
              return path.join('>');
            })
            .concat(
              variantHandles.map(function (handle) {
                return normalizeVariantHandle(handle);
              })
            )
            .concat(
              customHandles.map(function (handle) {
                return normalizeHandle(handle);
              })
            )
            .sort()
            .join('|');

      var force = options.force === true;

      if (!force && handlesKey === lastAppliedKey) {
        return;
      }

      lastAppliedKey = handlesKey;

      var visibleCount = 0;
      var grid = productsHolder.getAttribute('data-total-results') !== null ? productsHolder : null;

      productItems.forEach(function (item) {
        if (!item || item.nodeType !== 1) {
          return;
        }

        var promo = isPromoItem(item);
        var rawHandles = item.getAttribute('data-category-handles') || '';
        var itemHandles = rawHandles
          .split(',')
          .map(function (value) {
            return normalizeHandle(value);
          })
          .filter(function (value) {
            return value.length > 0;
          });

        var itemHandleSet = new Set(itemHandles);
        var itemVariantSet = getVariantNameSetForItem(item);
        var itemCustomSet = getCustomHandleSetForItem(item);
        // Per card, choose the first active variant token this product supports
        var matchedVariantToken = promo ? '' : resolveVariantTokenForItem(itemVariantSet, orderedVariantTokens);
        var matches;

        if (promo) {
          matches = !hasFilters;
        } else {
          var categoryMatches =
            categoryPaths.length === 0 ||
            categoryPaths.some(function (path) {
              return path.every(function (handle) {
                var tokens = getHandleTokens(handle);
                if (!tokens.length) {
                  return false;
                }

                return tokens.some(function (token) {
                  return itemHandleSet.has(token);
                });
              });
            });

          var variantMatches = orderedVariantTokens.length === 0 || matchedVariantToken !== '';

          var customMatches =
            customHandles.length === 0 ||
            customHandles.some(function (handle) {
              var normalized = normalizeHandle(handle);
              if (!normalized) {
                return false;
              }
              return itemCustomSet.has(normalized);
            });

          matches = categoryMatches && variantMatches && customMatches;
        }

        if (!promo) {
          // Image swapping is independent from visibility logic
          applyVariantImagesForItem(item, matchedVariantToken);
        }

        if (matches) {
          item.removeAttribute('data-horizontal-filter-hidden');
          item.style.display = '';

          if (!promo) {
            visibleCount += 1;
          }
        } else {
          item.setAttribute('data-horizontal-filter-hidden', 'true');
          item.style.display = 'none';
        }
      });

      if (grid) {
        grid.setAttribute('data-total-results', String(visibleCount));
      }

      productsHolder.setAttribute('data-visible-count', String(visibleCount));

      if (collectionSection && collectionSection.dataset) {
        collectionSection.dataset.collectionItemCount = String(visibleCount);
      }

      updateResultsCount(visibleCount);
      syncNoResultsState(visibleCount);

      if (options.dispatch !== false) {
        dispatchPaginationUpdate(visibleCount);
      }
    }

    function dispatchPaginationUpdate(visibleCount) {
      try {
        ensureProductContext();

        var detail = {
          source: 'horizontal-filter',
          visibleCount: visibleCount,
          filteredCount: visibleCount,
          totalResults: visibleCount,
          resultsCount: visibleCount,
          handlesKey: lastAppliedKey,
        };

        if (collectionSection && collectionSection.dataset && collectionSection.dataset.sectionId) {
          detail.sectionId = collectionSection.dataset.sectionId;
        }

        document.dispatchEvent(
          new CustomEvent('collection:updated', {
            detail: detail,
          })
        );
      } catch (error) {
        console.log('Error dispatching pagination update:', error);
      }
    }

    function updateResultsCount(count) {
      var counters = document.querySelectorAll('[data-results-count]');

      counters.forEach(function (el) {
        var templatesAttr = el.dataset.resultsTemplates || el.getAttribute('data-results-templates');
        var templates = null;

        if (templatesAttr) {
          try {
            templates = JSON.parse(templatesAttr);
          } catch (error) {
            templates = null;
          }
        }

        var templateText;
        if (templates) {
          if (count === 0 && templates.zero) {
            templateText = templates.zero;
          } else if (count === 1 && templates.one) {
            templateText = templates.one;
          } else if (templates.many) {
            templateText = templates.many;
          }
        }

        if (!templateText) {
          templateText = String(count);
        }

        var output = templateText.replace(/\[\[count\]\]/g, count);
        el.innerHTML = output;
        el.setAttribute('data-results-initial', count);
        el.dataset.resultsCount = count;
      });
    }

    function getListContext(snapshot) {
      var path = getActiveDrillPath(snapshot);

      if (!path.length) {
        return {
          nodes: mapEntriesToNodes(filterData.filters),
          activeHandle: null,
          mode: 'root',
        };
      }

      var lastHandle = path[path.length - 1];
      var lastOption = resolveHandleToOption(lastHandle);

      if (lastOption && lastOption.hasChildren) {
        return {
          nodes: mapEntriesToNodes(lastOption.node.data.children),
          activeHandle: null,
          mode: 'children',
        };
      }

      var parentHandle = lastOption && lastOption.node.parent ? lastOption.node.parent : null;

      if (parentHandle) {
        var parentOption = resolveHandleToOption(parentHandle);

        if (parentOption && parentOption.hasChildren) {
          return {
            nodes: mapEntriesToNodes(parentOption.node.data.children),
            activeHandle: lastHandle,
            mode: 'siblings',
          };
        }
      }

      return {
        nodes: mapEntriesToNodes(filterData.filters),
        activeHandle: lastHandle,
        mode: 'root',
      };
    }

    function resolveHandleToOption(handle) {
      if (!handle) {
        return null;
      }

      var node = NativeCategoryFilter.getNode(handle);
      return node ? nodeToOption(node) : null;
    }

    function getNodeForEntry(entry) {
      if (!entry || !window.NativeCategoryFilter) {
        return null;
      }

      var normalizedId = entry.id ? normalizeHandle(entry.id) : '';
      var normalizedMeta = entry.metaobject_handle ? normalizeHandle(entry.metaobject_handle) : '';

      if (normalizedId && typeof NativeCategoryFilter.getNodeById === 'function') {
        var byIdNode = NativeCategoryFilter.getNodeById(entry.id);
        if (byIdNode) {
          return byIdNode;
        }
      }

      var candidates = [entry.handle, entry.metaobject_handle, entry.id, entry.name];
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        if (!candidate) {
          continue;
        }
        var candidateNode = NativeCategoryFilter.getNode(candidate);
        if (!candidateNode) {
          continue;
        }

        if (normalizedId) {
          var candidateId = candidateNode.data && normalizeHandle(candidateNode.data.id);
          if (candidateId && candidateId !== normalizedId) {
            continue;
          }
        }

        if (normalizedMeta) {
          var candidateMeta = candidateNode.data && normalizeHandle(candidateNode.data.metaobject_handle);
          if (candidateMeta && candidateMeta !== normalizedMeta) {
            continue;
          }
        }

        return candidateNode;
      }

      if (normalizedId && typeof NativeCategoryFilter.getFilterHandles === 'function') {
        var handles = NativeCategoryFilter.getFilterHandles();
        if (handles && typeof handles.forEach === 'function') {
          var matchedNode = null;
          handles.forEach(function (handle) {
            if (matchedNode) {
              return;
            }

            var node = NativeCategoryFilter.getNode(handle);
            if (!node || !node.data) {
              return;
            }

            var candidateId = normalizeHandle(node.data.id);
            if (candidateId === normalizedId) {
              if (!normalizedMeta || normalizeHandle(node.data.metaobject_handle) === normalizedMeta) {
                matchedNode = node;
              }
            }
          });

          if (matchedNode) {
            return matchedNode;
          }
        }
      }

      return null;
    }

    function mapEntriesToNodes(entries) {
      if (!Array.isArray(entries)) {
        return [];
      }

      return entries
        .map(function (entry) {
          var node = getNodeForEntry(entry);
          return node ? nodeToOption(node) : null;
        })
        .filter(Boolean);
    }

    function nodeToOption(node) {
      return {
        handle: node.handle,
        name: node.name,
        hasChildren: node.data && Array.isArray(node.data.children) && node.data.children.length > 0,
        node: node,
      };
    }

    function getFilterNode(handle) {
      if (!handle || !window.NativeCategoryFilter || typeof NativeCategoryFilter.getNode !== 'function') {
        return null;
      }

      return NativeCategoryFilter.getNode(handle);
    }

    function getHandleGroupType(handle) {
      var node = getFilterNode(handle);
      return node && node.data ? node.data.group_type || '' : '';
    }

    function isVariantHandle(handle) {
      if (!handle) {
        return false;
      }

      if (variantHandleCache.has(handle)) {
        return variantHandleCache.get(handle);
      }

      var groupType = getHandleGroupType(handle);
      var result = groupType === 'variant_scent';
      variantHandleCache.set(handle, result);
      return result;
    }

    function isCustomSidebarHandle(handle) {
      return getHandleGroupType(handle) === 'sidebar_custom';
    }

    function getVariantHandleName(handle) {
      var node = getFilterNode(handle);

      if (!node) {
        return '';
      }

      var label =
        (node.data && (node.data.token || node.data.scent_name || node.data.name)) || node.handle || node.name || '';
      if (!label) {
        return '';
      }

      return normalizeVariantHandle(label);
    }

    function getVariantNameSetForItem(item) {
      if (!item) {
        return new Set();
      }

      var raw = item.getAttribute('data-variant-handles') || '';

      if (!raw) {
        return new Set();
      }

      var entries = raw
        .split('||')
        .map(function (entry) {
          return normalizeVariantHandle(entry);
        })
        .filter(function (entry) {
          return entry.length > 0;
        });

      return new Set(entries);
    }

    function getCustomHandleSetForItem(item) {
      if (!item) {
        return new Set();
      }

      var raw = item.getAttribute('data-sidebar-custom-handles') || '';
      if (!raw) {
        return new Set();
      }

      var entries = raw
        .split(',')
        .map(function (entry) {
          return normalizeHandle(entry);
        })
        .filter(function (entry) {
          return entry.length > 0;
        });

      return new Set(entries);
    }

    function getVariantImageMapForItem(item) {
      if (!item) {
        return null;
      }

      // Parse once per card and reuse across filter interactions
      if (item.__variantImageMapParsed === true) {
        return item.__variantImageMap || null;
      }

      var parsedMap = {};
      var imageMapScript = item.querySelector('[data-variant-image-map]');

      if (imageMapScript) {
        try {
          var rawMap = JSON.parse(imageMapScript.textContent || '{}');
          if (rawMap && typeof rawMap === 'object' && !Array.isArray(rawMap)) {
            Object.keys(rawMap).forEach(function (rawKey) {
              var normalizedKey = normalizeVariantHandle(rawKey);
              if (!normalizedKey) {
                return;
              }

              var rawEntry = rawMap[rawKey];
              if (!rawEntry || typeof rawEntry !== 'object') {
                return;
              }

              parsedMap[normalizedKey] = {
                // First image
                primary_html: typeof rawEntry.primary_html === 'string' ? rawEntry.primary_html : '',
                // Second image
                secondary_html: typeof rawEntry.secondary_html === 'string' ? rawEntry.secondary_html : '',
                // Variant badge
                badge_html: typeof rawEntry.badge_html === 'string' ? rawEntry.badge_html : '',
                // Variant size
                size_value: typeof rawEntry.size_value === 'string' ? rawEntry.size_value : '',
                // Variant scent
                scent_value: typeof rawEntry.scent_value === 'string' ? rawEntry.scent_value : '',
                // Product URL with variant id
                product_url: typeof rawEntry.product_url === 'string' ? rawEntry.product_url : '',
                variant_id: rawEntry.variant_id != null ? String(rawEntry.variant_id) : '',
              };
            });
          }
        } catch (error) {
          parsedMap = {};
        }
      }

      item.__variantImageMap = parsedMap;
      item.__variantImageMapParsed = true;
      return parsedMap;
    }

    function getImageLinkForItem(item) {
      if (!item) {
        return null;
      }

      return item.querySelector('.product-item__image-link');
    }

    function getPrimaryImageNodeForItem(item, imageLink) {
      var link = imageLink || getImageLinkForItem(item);
      if (!link) {
        return null;
      }

      var imageNodes = Array.prototype.slice.call(link.querySelectorAll('.product-item__image'));
      for (var i = 0; i < imageNodes.length; i += 1) {
        if (!imageNodes[i].classList.contains('product-item__image--two')) {
          return imageNodes[i];
        }
      }

      return null;
    }

    function getSecondaryImageNodeForItem(item, imageLink) {
      var link = imageLink || getImageLinkForItem(item);
      if (!link) {
        return null;
      }

      return link.querySelector('.product-item__image--two');
    }

    function getVariantCustomBadgeNodesForItem(item, imageLink) {
      var link = imageLink || getImageLinkForItem(item);
      if (!link) {
        return [];
      }

      return Array.prototype.slice.call(link.querySelectorAll('.product-cards.product-badges'));
    }

    function getVariantSizeNodeForItem(item) {
      if (!item) {
        return null;
      }

      return item.querySelector('.product-variant-size');
    }

    function getVariantScentNodeForItem(item) {
      if (!item) {
        return null;
      }

      return item.querySelector('.product-item__product-scent-title');
    }

    function getScentOptionsButtonForItem(item) {
      if (!item) {
        return null;
      }

      return item.querySelector('[data-product-item-scent-options]');
    }

    function createImageNodeFromHtml(html) {
      var markup = typeof html === 'string' ? html.trim() : '';
      if (!markup) {
        return null;
      }

      var container = document.createElement('div');
      container.innerHTML = markup;
      return container.firstElementChild;
    }

    function createNodesFromHtml(html) {
      var markup = typeof html === 'string' ? html.trim() : '';
      if (!markup) {
        return [];
      }

      var container = document.createElement('div');
      container.innerHTML = markup;
      return Array.prototype.slice.call(container.children);
    }

    function setItemProductUrlForItem(item, productUrl) {
      if (!item) {
        return;
      }

      var nextUrl = typeof productUrl === 'string' ? productUrl.trim() : '';
      if (nextUrl) {
        item.setAttribute('data-url', nextUrl);
      } else {
        item.removeAttribute('data-url');
      }
    }

    function setScentButtonUrlForItem(item, productUrl) {
      var scentButton = getScentOptionsButtonForItem(item);
      if (!scentButton) {
        return;
      }

      var nextUrl = typeof productUrl === 'string' ? productUrl.trim() : '';
      if (nextUrl) {
        scentButton.setAttribute('data-product-url', nextUrl);
      } else {
        scentButton.removeAttribute('data-product-url');
      }
    }

    function setVariantSizeHtmlForItem(item, sizeHtml) {
      var sizeNode = getVariantSizeNodeForItem(item);
      if (!sizeNode) {
        return;
      }

      sizeNode.innerHTML = typeof sizeHtml === 'string' ? sizeHtml : '';
    }

    function setVariantScentTextForItem(item, scentText) {
      var scentNode = getVariantScentNodeForItem(item);
      if (!scentNode) {
        return;
      }

      scentNode.textContent = typeof scentText === 'string' ? scentText : '';
    }

    function applyVariantBadgeMarkupForItem(item, badgeHtml) {
      var imageLink = getImageLinkForItem(item);
      if (!imageLink) {
        return;
      }

      // Replace only custom card badges, keep native sale/new/sold-out badges untouched
      getVariantCustomBadgeNodesForItem(item, imageLink).forEach(function (node) {
        node.remove();
      });

      var nextBadgeNodes = createNodesFromHtml(badgeHtml);
      if (!nextBadgeNodes.length) {
        return;
      }

      var primaryNode = getPrimaryImageNodeForItem(item, imageLink);
      nextBadgeNodes.forEach(function (node) {
        if (primaryNode) {
          imageLink.insertBefore(node, primaryNode);
        } else {
          imageLink.appendChild(node);
        }
      });
    }

    function applyVariantSizeValueForItem(item, sizeValue) {
      var sizeNode = getVariantSizeNodeForItem(item);
      if (!sizeNode) {
        return;
      }

      var normalizedSize = typeof sizeValue === 'string' ? sizeValue.trim() : '';
      sizeNode.textContent = normalizedSize ? '\u00a0(' + normalizedSize + ')' : '';
    }

    function applyVariantScentValueForItem(item, scentValue) {
      var normalizedScent = typeof scentValue === 'string' ? scentValue.trim() : '';
      setVariantScentTextForItem(item, normalizedScent);
    }

    function ensureOriginalVariantStateForItem(item) {
      if (!item || item.__variantCardOriginalCaptured) {
        return;
      }

      // Capture the server-rendered card state so we can always revert cleanly.
      var imageLink = getImageLinkForItem(item);
      var primaryNode = getPrimaryImageNodeForItem(item, imageLink);
      var secondaryNode = getSecondaryImageNodeForItem(item, imageLink);
      var customBadgeNodes = getVariantCustomBadgeNodesForItem(item, imageLink);
      var sizeNode = getVariantSizeNodeForItem(item);
      var scentNode = getVariantScentNodeForItem(item);
      var scentButton = getScentOptionsButtonForItem(item);

      item.__variantCardOriginal = {
        primary_html: primaryNode ? primaryNode.outerHTML : '',
        secondary_html: secondaryNode ? secondaryNode.outerHTML : '',
        badge_html: customBadgeNodes
          .map(function (node) {
            return node.outerHTML;
          })
          .join(''),
        size_html: sizeNode ? sizeNode.innerHTML : '',
        scent_text: scentNode ? scentNode.textContent || '' : '',
        product_url: item.getAttribute('data-url') || '',
        scent_button_url: scentButton ? scentButton.getAttribute('data-product-url') || '' : '',
      };
      item.__variantCardOriginalCaptured = true;
      item.__variantCardAppliedToken = '__original__';
    }

    function replaceVariantImageNodes(item, primaryHtml, secondaryHtml) {
      var imageLink = getImageLinkForItem(item);
      if (!imageLink) {
        return false;
      }

      var nextPrimary = createImageNodeFromHtml(primaryHtml);
      if (!nextPrimary) {
        return false;
      }

      var currentPrimary = getPrimaryImageNodeForItem(item, imageLink);
      var currentSecondary = getSecondaryImageNodeForItem(item, imageLink);

      if (currentPrimary) {
        currentPrimary.replaceWith(nextPrimary);
      } else if (currentSecondary) {
        imageLink.insertBefore(nextPrimary, currentSecondary);
      } else {
        imageLink.appendChild(nextPrimary);
      }

      currentSecondary = getSecondaryImageNodeForItem(item, imageLink);

      if (secondaryHtml) {
        var nextSecondary = createImageNodeFromHtml(secondaryHtml);

        if (nextSecondary) {
          if (currentSecondary) {
            currentSecondary.replaceWith(nextSecondary);
          } else {
            imageLink.appendChild(nextSecondary);
          }
        } else if (currentSecondary) {
          currentSecondary.remove();
        }
      } else if (currentSecondary) {
        currentSecondary.remove();
      }

      return true;
    }

    function applyVariantMetadataForItem(item, imageEntry) {
      if (!item || !imageEntry) {
        return;
      }

      applyVariantBadgeMarkupForItem(item, imageEntry.badge_html || '');
      applyVariantSizeValueForItem(item, imageEntry.size_value || '');
      applyVariantScentValueForItem(item, imageEntry.scent_value || '');

      var nextUrl = imageEntry.product_url || '';
      if (!nextUrl && item.__variantCardOriginal) {
        nextUrl = item.__variantCardOriginal.product_url || '';
      }

      setItemProductUrlForItem(item, nextUrl);
      setScentButtonUrlForItem(item, nextUrl);
    }

    function ensureVariantImageHoverFallback(item) {
      if (!item || item.__variantImageHoverBound === true) {
        return;
      }

      // Safety net: keep hover behavior stable after DOM replacement.
      item.__variantImageHoverBound = true;

      item.addEventListener('mouseenter', function () {
        var secondary = getSecondaryImageNodeForItem(item);
        if (secondary) {
          secondary.classList.add('active');
        }
      });

      item.addEventListener('mouseleave', function () {
        var secondary = getSecondaryImageNodeForItem(item);
        if (secondary) {
          secondary.classList.remove('active');
        }
      });
    }

    function restoreOriginalVariantImagesForItem(item) {
      if (!item) {
        return;
      }

      ensureOriginalVariantStateForItem(item);
      var original = item.__variantCardOriginal;
      if (!original || !original.primary_html) {
        return;
      }

      replaceVariantImageNodes(item, original.primary_html, original.secondary_html || '');
    }

    function restoreVariantMetadataForItem(item) {
      if (!item) {
        return;
      }

      ensureOriginalVariantStateForItem(item);
      var original = item.__variantCardOriginal;
      if (!original) {
        return;
      }

      applyVariantBadgeMarkupForItem(item, original.badge_html || '');
      setVariantSizeHtmlForItem(item, original.size_html || '');
      setVariantScentTextForItem(item, original.scent_text || '');
      setItemProductUrlForItem(item, original.product_url || '');
      setScentButtonUrlForItem(item, original.scent_button_url || '');
    }

    function restoreVariantStateForItem(item) {
      if (!item) {
        return;
      }

      ensureOriginalVariantStateForItem(item);
      if (item.__variantCardAppliedToken === '__original__') {
        return;
      }

      restoreOriginalVariantImagesForItem(item);
      restoreVariantMetadataForItem(item);
      item.__variantCardAppliedToken = '__original__';
    }

    function applyVariantImagesForItem(item, variantToken) {
      if (!item) {
        return;
      }

      ensureOriginalVariantStateForItem(item);
      ensureVariantImageHoverFallback(item);

      var normalizedToken = normalizeVariantHandle(variantToken);
      if (!normalizedToken) {
        restoreVariantStateForItem(item);
        return;
      }

      if (item.__variantCardAppliedToken === normalizedToken) {
        return;
      }

      var imageMap = getVariantImageMapForItem(item);
      var imageEntry = imageMap && imageMap[normalizedToken] ? imageMap[normalizedToken] : null;

      // Missing token payload means this card should revert to original product state.
      if (!imageEntry) {
        restoreVariantStateForItem(item);
        return;
      }

      // Metadata (badges/size/scent/URL) can still update even if image payload is blank.
      applyVariantMetadataForItem(item, imageEntry);

      if (imageEntry.primary_html) {
        var didReplace = replaceVariantImageNodes(item, imageEntry.primary_html, imageEntry.secondary_html || '');
        if (!didReplace) {
          restoreOriginalVariantImagesForItem(item);
        }
      } else {
        restoreOriginalVariantImagesForItem(item);
      }

      item.__variantCardAppliedToken = normalizedToken;
    }

    function resolveVariantTokenForItem(itemVariantSet, orderedVariantTokens) {
      if (!itemVariantSet || itemVariantSet.size === 0 || !Array.isArray(orderedVariantTokens)) {
        return '';
      }

      // First active token that matches the current card wins.
      for (var i = 0; i < orderedVariantTokens.length; i += 1) {
        var token = orderedVariantTokens[i];
        if (token && itemVariantSet.has(token)) {
          return token;
        }
      }

      return '';
    }

    function getBreadcrumbContext() {
      var nav = document.querySelector('nav[aria-label="breadcrumbs"]');
      if (!nav) {
        return null;
      }

      var li = nav.querySelector('li.breadcrumb-wrapper') || nav.querySelector('ol > li');
      if (!li) {
        return null;
      }

      var sep = li.querySelector('svg.breadcrumb-separator, svg.breadcrumb-seperator');
      if (!sep) {
        return { li: li, sep: null };
      }

      return { li: li, sep: sep };
    }

    function ensureProductContext() {
      if (productsHolder && document.body && document.body.contains(productsHolder)) {
        productsHolder.style.minWidth = '100%';
        return;
      }

      collectionSection = document.querySelector('[data-section-type="collection"]');
      productsHolder = collectionSection ? collectionSection.querySelector('.product-item-holder') : null;

      if (productsHolder) {
        productsHolder.style.minWidth = '100%';
      }
    }

    function cacheProductItems() {
      ensureProductContext();

      if (!productsHolder) {
        productItems = [];
        return;
      }

      productItems = Array.from(productsHolder.querySelectorAll('.product-item'));

      productItems.forEach(function (item) {
        ensureOriginalVariantStateForItem(item);
        ensureVariantImageHoverFallback(item);
      });
    }

    function ensureNoResultsContainer() {
      ensureProductContext();

      if (!productsHolder) {
        return null;
      }

      if (noResultsContainer && document.body.contains(noResultsContainer)) {
        return noResultsContainer;
      }

      var parent = productsHolder.parentNode;
      if (!parent) {
        return null;
      }

      if (!noResultsContainer) {
        var existing = parent.querySelector('.collection__empty:not([data-horizontal-no-results])');
        if (existing) {
          noResultsContainer = existing;
          noResultsContainer.setAttribute('data-horizontal-no-results', 'true');
        }
      }

      if (!noResultsContainer) {
        noResultsContainer = document.createElement('div');
        noResultsContainer.className = 'collection__empty collection__empty--centered';
        noResultsContainer.setAttribute('data-horizontal-no-results', 'true');

        var message = document.createElement('div');
        message.className = 'collection__empty-message';
        message.textContent = noResultsStrings.heading;

        var helper = document.createElement('div');
        helper.className = 'no-products__clear-filters-text';

        var helperHint = document.createElement('span');
        helperHint.textContent = noResultsStrings.useFewer;

        // TODO: Fix, turn to button to clear
        var clearButton = document.createElement('span');
        // clearButton.type = 'button';
        // clearButton.className = 'btn btn--text-link fs-body-100';
        clearButton.style.textTransform = 'lowercase';
        // clearButton.setAttribute('data-clear-all-filters', '');
        clearButton.textContent = noResultsStrings.clearAll;

        helper.appendChild(helperHint);
        helper.appendChild(document.createTextNode(' '));
        helper.appendChild(clearButton);
        noResultsContainer.appendChild(message);
        noResultsContainer.appendChild(helper);
      }

      noResultsContainer.style.display = 'none';
      noResultsContainer.setAttribute('hidden', 'true');

      if (!noResultsContainer.parentNode) {
        parent.insertBefore(noResultsContainer, productsHolder.nextSibling);
      }

      return noResultsContainer;
    }

    function syncNoResultsState(count) {
      var container = ensureNoResultsContainer();
      if (!container) {
        return;
      }

      if (count <= 0) {
        container.style.display = '';
        container.removeAttribute('hidden');
      } else {
        container.style.display = 'none';
        container.setAttribute('hidden', 'true');
      }
    }

    function isPromoItem(item) {
      return !!(item && item.nodeType === 1 && item.hasAttribute('data-promo-tile'));
    }

    function onCollectionUpdated(event) {
      if (event && event.detail && event.detail.source === 'horizontal-filter') {
        return;
      }

      ensureProductContext();

      if (
        collectionSection &&
        event &&
        event.detail &&
        event.detail.sectionId &&
        collectionSection.dataset &&
        collectionSection.dataset.sectionId &&
        collectionSection.dataset.sectionId !== String(event.detail.sectionId)
      ) {
        return;
      }

      cacheProductItems();
      applyProductFilters({ force: true });
    }

    function monitorSidebarVisibility() {
      var sidebar = document.getElementById('filter-sidebar');
      if (!sidebar) {
        return;
      }

      function updateSidebarState() {
        var hidden = sidebar.getAttribute('aria-hidden') === 'true';
        NativeCategoryFilter.setSidebarOpen(!hidden, { source: 'sidebar-observer' });
      }

      updateSidebarState();

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            updateSidebarState();
          }
        });
      });

      observer.observe(sidebar, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    function attachSidebarToggleListeners() {
      var toggle = document.querySelector('[data-sidebar-toggle]');
      if (!toggle) {
        return;
      }

      toggle.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          NativeCategoryFilter.setSidebarOpen(expanded, { source: 'sidebar-toggle' });
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-sidebar-filter-logic"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-sidebar-filter]');

    if (!root || root.dataset.sidebarFilterInitialized === 'true') {
      return;
    }

    var dataNode = root.parentElement && root.parentElement.querySelector('[data-sidebar-filter-data]');

    if (!dataNode) {
      var sibling = root.nextSibling;

      while (sibling) {
        if (sibling.nodeType === 1 && sibling.hasAttribute('data-sidebar-filter-data')) {
          dataNode = sibling;
          break;
        }
        sibling = sibling.nextSibling;
      }
    }

    if (!dataNode) {
      return;
    }

    var parsedData;

    try {
      parsedData = JSON.parse(dataNode.textContent.trim());
    } catch (error) {
      console.warn('Sidebar filter: unable to parse filter data.', error);
      return;
    }

    var categoryFilters = parsedData && Array.isArray(parsedData.category_filters) ? parsedData.category_filters : [];
    var variantFilters = parsedData && Array.isArray(parsedData.variant_filters) ? parsedData.variant_filters : [];
    var customFilters = parsedData && Array.isArray(parsedData.custom_filters) ? parsedData.custom_filters : [];

    var combinedFilters = []
      .concat(Array.isArray(categoryFilters) ? categoryFilters : [])
      .concat(Array.isArray(variantFilters) ? variantFilters : [])
      .concat(Array.isArray(customFilters) ? customFilters : []);

    if (!parsedData || combinedFilters.length === 0) {
      return;
    }

    if (!window.NativeCategoryFilter) {
      console.warn('Sidebar filter: NativeCategoryFilter is not available.');
      return;
    }

    NativeCategoryFilter.ensureData({ filters: combinedFilters });
    if (typeof NativeCategoryFilter.applyUrlFilters === 'function') {
      NativeCategoryFilter.applyUrlFilters({ source: 'url', notify: false });
    }

    var treeContainer = root.querySelector('[data-sidebar-filter-tree]');
    var tagsContainer = root.querySelector('[data-sidebar-filter-tags]');
    var clearButton = root.querySelector('[data-sidebar-filter-clear]');
    var toggleButton = root.querySelector('[data-sidebar-filter-toggle]');
    var section = root.querySelector('[data-sidebar-filter-section]');
    var variantSection = root.querySelector('[data-variant-filter-section]');
    var variantToggle = variantSection ? variantSection.querySelector('[data-variant-filter-toggle]') : null;
    var variantCheckboxes = variantSection
      ? Array.prototype.slice.call(variantSection.querySelectorAll('[data-variant-filter-checkbox]'))
      : [];
    var customSections = Array.prototype.slice.call(root.querySelectorAll('[data-custom-filter-section]'));
    var customCheckboxes = [];
    customSections.forEach(function (customSection) {
      customCheckboxes = customCheckboxes.concat(
        Array.prototype.slice.call(customSection.querySelectorAll('[data-custom-filter-checkbox]'))
      );
    });
    var scentFamilyToggles = variantSection
      ? Array.prototype.slice.call(variantSection.querySelectorAll('[data-scent-family-toggle]'))
      : [];
    var scentFamilyMap = new Map();
    var variantHandleToFamily = new Map();

    if (!tagsContainer) {
      return;
    }

    var inputsByHandle = new Map();
    var itemsByHandle = new Map();
    var childListsByHandle = new Map();
    var expandedHandles = new Set();
    var unsubscribe;

    function normalizeEntryKey(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function getNodeForEntry(entry) {
      if (!entry || !window.NativeCategoryFilter) {
        return null;
      }

      var normalizedId = entry.id ? normalizeEntryKey(entry.id) : '';
      var normalizedMeta = entry.metaobject_handle ? normalizeEntryKey(entry.metaobject_handle) : '';

      if (normalizedId && typeof NativeCategoryFilter.getNodeById === 'function') {
        var byIdNode = NativeCategoryFilter.getNodeById(entry.id);
        if (byIdNode) {
          return byIdNode;
        }
      }

      var candidates = [entry.handle, entry.metaobject_handle, entry.id, entry.name];
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        if (!candidate) {
          continue;
        }

        var node = NativeCategoryFilter.getNode(candidate);
        if (!node) {
          continue;
        }

        if (normalizedId) {
          var candidateId = node.data && normalizeEntryKey(node.data.id);
          if (candidateId && candidateId !== normalizedId) {
            continue;
          }
        }

        if (normalizedMeta) {
          var candidateMeta = node.data && normalizeEntryKey(node.data.metaobject_handle);
          if (candidateMeta && candidateMeta !== normalizedMeta) {
            continue;
          }
        }

        return node;
      }

      if (normalizedId && typeof NativeCategoryFilter.getFilterHandles === 'function') {
        var handles = NativeCategoryFilter.getFilterHandles();
        if (handles && typeof handles.forEach === 'function') {
          var matched = null;
          handles.forEach(function (handle) {
            if (matched) {
              return;
            }

            var node = NativeCategoryFilter.getNode(handle);
            if (!node || !node.data) {
              return;
            }

            var candidateId = normalizeEntryKey(node.data.id);
            if (candidateId === normalizedId) {
              if (!normalizedMeta || normalizeEntryKey(node.data.metaobject_handle) === normalizedMeta) {
                matched = node;
              }
            }
          });

          if (matched) {
            return matched;
          }
        }
      }

      return null;
    }

    function setExpanded(handle, expanded) {
      var listItem = itemsByHandle.get(handle);
      var childList = childListsByHandle.get(handle);

      if (!listItem || !childList) {
        return;
      }

      if (expanded) {
        listItem.classList.add('custom-sidebar-filter__item--expanded');
      } else {
        listItem.classList.remove('custom-sidebar-filter__item--expanded');
      }
    }

    function collectAncestors(handle, bucket) {
      if (!handle || !bucket) {
        return;
      }

      var visited = new Set();
      var currentHandle = handle;

      while (currentHandle && !visited.has(currentHandle)) {
        visited.add(currentHandle);
        bucket.add(currentHandle);

        var node = NativeCategoryFilter.getNode(currentHandle);
        if (!node || !node.parent) {
          break;
        }

        currentHandle = node.parent;
      }
    }

    function expandPathToHandle(handle) {
      if (!handle || typeof NativeCategoryFilter.getNode !== 'function') {
        return;
      }

      var bucket = new Set();
      collectAncestors(handle, bucket);

      bucket.forEach(function (entry) {
        if (childListsByHandle.has(entry)) {
          expandedHandles.add(entry);
          setExpanded(entry, true);
        }
      });
    }

    function collapseBranch(handle) {
      if (!handle) {
        return;
      }

      var handlesToCollapse = [handle];

      if (typeof NativeCategoryFilter.getDescendants === 'function') {
        try {
          var descendants = NativeCategoryFilter.getDescendants(handle);
          if (Array.isArray(descendants)) {
            handlesToCollapse = handlesToCollapse.concat(descendants);
          }
        } catch (error) {
          console.warn('Sidebar filter: unable to resolve descendants for collapse.', error);
        }
      }

      handlesToCollapse.forEach(function (entry) {
        expandedHandles.delete(entry);
        setExpanded(entry, false);
      });
    }

    function collapseAll() {
      expandedHandles.clear();
      itemsByHandle.forEach(function (_item, handle) {
        setExpanded(handle, false);
      });
    }

    function syncExpandedState(snapshot) {
      var handlesToExpand = new Set(expandedHandles);

      if (snapshot) {
        if (Array.isArray(snapshot.activePaths)) {
          snapshot.activePaths.forEach(function (path) {
            if (!Array.isArray(path)) {
              return;
            }
            path.forEach(function (handle) {
              collectAncestors(handle, handlesToExpand);
            });
          });
        }

        if (Array.isArray(snapshot.drillPath)) {
          snapshot.drillPath.forEach(function (handle) {
            collectAncestors(handle, handlesToExpand);
          });
        }
      }

      itemsByHandle.forEach(function (_item, handle) {
        setExpanded(handle, handlesToExpand.has(handle));
      });

      Array.from(expandedHandles).forEach(function (handle) {
        if (!itemsByHandle.has(handle) || !childListsByHandle.has(handle)) {
          expandedHandles.delete(handle);
        }
      });
    }

    function createCheckbox(item, depth) {
      var listItem = document.createElement('li');
      listItem.className = 'custom-sidebar-filter__item custom-sidebar-filter__item--level-' + depth;

      if (Array.isArray(item.children) && item.children.length > 0) {
        listItem.classList.add('custom-sidebar-filter__item--has-children');
      }

      var label = document.createElement('label');
      label.className = 'custom-sidebar-filter__option';

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'custom-sidebar-filter__checkbox';

      var node = getNodeForEntry(item);

      if (!node) {
        return null;
      }

      input.dataset.filterHandle = node.handle;
      input.dataset.filterLabel = node.name;

      var indicator = document.createElement('span');
      indicator.className = 'custom-sidebar-filter__indicator';

      var text = document.createElement('span');
      text.className = 'custom-sidebar-filter__label tw:body-s tw:font-medium';
      text.textContent = node.name;

      label.appendChild(input);
      label.appendChild(indicator);
      label.appendChild(text);
      listItem.appendChild(label);

      inputsByHandle.set(node.handle, input);
      itemsByHandle.set(node.handle, listItem);
      listItem.dataset.filterHandle = node.handle;

      input.addEventListener('change', function () {
        NativeCategoryFilter.handleCheckbox(node.handle, input.checked, {
          source: 'sidebar',
          clearAncestorExplicit: false,
        });

        if (input.checked) {
          expandPathToHandle(node.handle);
        } else {
          collapseBranch(node.handle);
        }
      });

      label.addEventListener('click', function () {
        expandPathToHandle(node.handle);
      });

      if (Array.isArray(item.children) && item.children.length > 0) {
        var childList = renderTree(item.children, listItem, depth + 1);

        if (childList) {
          listItem.classList.add('custom-sidebar-filter__item--collapsible');
          childListsByHandle.set(node.handle, childList);
        }
      }

      return listItem;
    }

    function renderTree(nodes, container, depth) {
      if (!Array.isArray(nodes) || nodes.length === 0) {
        return;
      }

      var list = document.createElement('ul');
      list.className = 'custom-sidebar-filter__items custom-sidebar-filter__items--level-' + depth;

      if (depth > 0) {
        list.style.marginLeft = (20 * depth).toString() + 'px';
      }

      nodes.forEach(function (item) {
        var element = createCheckbox(item, depth);

        if (element) {
          list.appendChild(element);
        }
      });

      container.appendChild(list);

      if (depth > 0) {
        list.classList.add('custom-sidebar-filter__items--collapsible');
      }

      return list;
    }

    function renderTags(tags) {
      tagsContainer.innerHTML = '';

      if (!Array.isArray(tags) || tags.length === 0) {
        return;
      }

      var ordered = tags.slice().sort(function (a, b) {
        return a.order - b.order;
      });

      ordered.forEach(function (tag) {
        var node = NativeCategoryFilter.getNode(tag.handle);
        if (!node) {
          return;
        }

        var tagElement = document.createElement('div');
        tagElement.className = 'custom-sidebar-filter__tag';
        tagElement.dataset.filterHandle = node.handle;

        var text = document.createElement('span');
        text.className = 'custom-sidebar-filter__tag-text tw:label-medium';
        text.textContent = node.name;

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'custom-sidebar-filter__tag-remove';
        remove.setAttribute('aria-label', 'Remove ' + node.name);
        remove.innerHTML =
          '<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g opacity="0.5">' +
          '<path d="M11.25 4.25L3.75 11.75" stroke="#0E1029" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '<path d="M3.75 4.25L11.25 11.75" stroke="#0E1029" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '</g>' +
          '</svg>';

        remove.addEventListener('click', function () {
          NativeCategoryFilter.handleCheckbox(node.handle, false, { source: 'sidebar-tag' });
        });

        tagElement.appendChild(text);
        tagElement.appendChild(remove);
        tagsContainer.appendChild(tagElement);
      });
    }

    function applyState(snapshot) {
      if (!snapshot) {
        return;
      }

      var familyKeysToExpand = new Set();

      inputsByHandle.forEach(function (input, handle) {
        var isChecked = snapshot.checked.has(handle);

        input.checked = isChecked;
        input.indeterminate = false;

        if (isChecked && variantHandleToFamily.has(handle)) {
          familyKeysToExpand.add(variantHandleToFamily.get(handle));
        }
      });

      if (clearButton) {
        clearButton.disabled = snapshot.filterHandles.size === 0;
      }

      if (snapshot.filterHandles.size === 0) {
        root.classList.remove('is-filtered');
        collapseAll();
      } else {
        root.classList.add('is-filtered');
      }

      renderTags(snapshot.tags);
      syncExpandedState(snapshot);

      familyKeysToExpand.forEach(function (familyKey) {
        setScentFamilyExpanded(familyKey, true);
      });
    }

    function clearSelections() {
      NativeCategoryFilter.clearAll('sidebar');
    }

    function updateToggleSymbolForButton(button, expanded) {
      if (!button) {
        return;
      }

      button.textContent = expanded ? '-' : '+';
    }

    function updateToggleSymbol(expanded) {
      updateToggleSymbolForButton(toggleButton, expanded);
    }

    if (treeContainer && Array.isArray(categoryFilters) && categoryFilters.length > 0) {
      renderTree(categoryFilters, treeContainer, 0);
    }

    variantCheckboxes.forEach(function (input) {
      var handle = input.getAttribute('data-filter-handle');
      if (!handle) {
        return;
      }

      inputsByHandle.set(handle, input);
      var familyKey = input.getAttribute('data-scent-family-key') || '';
      if (familyKey) {
        variantHandleToFamily.set(handle, familyKey);
      }

      input.addEventListener('change', function () {
        NativeCategoryFilter.handleCheckbox(handle, input.checked, {
          source: 'sidebar-variant',
          clearAncestorExplicit: false,
        });
      });
    });

    customCheckboxes.forEach(function (input) {
      var handle = input.getAttribute('data-filter-handle');
      if (!handle) {
        return;
      }

      inputsByHandle.set(handle, input);

      input.addEventListener('change', function () {
        NativeCategoryFilter.handleCheckbox(handle, input.checked, {
          source: 'sidebar-custom',
          clearAncestorExplicit: false,
        });
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        clearSelections();
      });
      clearButton.disabled = true;
    }

    if (toggleButton && section) {
      toggleButton.addEventListener('click', function () {
        var expanded = toggleButton.getAttribute('aria-expanded') === 'true';
        var nextState = !expanded;

        toggleButton.setAttribute('aria-expanded', String(nextState));
        section.classList.toggle('custom-sidebar-filter__section--collapsed', !nextState);
        updateToggleSymbol(nextState);
      });

      updateToggleSymbol(true);
    }

    if (variantToggle && variantSection) {
      variantToggle.addEventListener('click', function () {
        var expanded = variantToggle.getAttribute('aria-expanded') === 'true';
        var nextState = !expanded;

        variantToggle.setAttribute('aria-expanded', String(nextState));
        variantSection.classList.toggle('custom-sidebar-filter__section--collapsed', !nextState);
        updateToggleSymbolForButton(variantToggle, nextState);
      });

      updateToggleSymbolForButton(variantToggle, true);
    }

    customSections.forEach(function (customSection) {
      var customToggle = customSection.querySelector('[data-custom-filter-toggle]');
      if (!customToggle) {
        return;
      }

      customToggle.addEventListener('click', function () {
        var expanded = customToggle.getAttribute('aria-expanded') === 'true';
        var nextState = !expanded;

        customToggle.setAttribute('aria-expanded', String(nextState));
        customSection.classList.toggle('custom-sidebar-filter__section--collapsed', !nextState);
        updateToggleSymbolForButton(customToggle, nextState);
      });

      updateToggleSymbolForButton(customToggle, true);
    });

    function setScentFamilyExpanded(familyKey, expanded) {
      if (!familyKey || !scentFamilyMap.has(familyKey)) {
        return;
      }

      var entry = scentFamilyMap.get(familyKey);
      if (!entry) {
        return;
      }

      if (entry.toggle) {
        entry.toggle.setAttribute('aria-expanded', String(expanded));
        updateToggleSymbolForButton(entry.toggle, expanded);
      }

      if (entry.list) {
        entry.list.hidden = !expanded;
      }

      if (entry.container) {
        entry.container.classList.toggle('custom-sidebar-filter__family--collapsed', !expanded);
      }
    }

    scentFamilyToggles.forEach(function (toggle) {
      var container = toggle.closest('[data-scent-family]');
      var list = container ? container.querySelector('[data-scent-family-items]') : null;
      var familyKey = container ? container.getAttribute('data-scent-family-key') || '' : '';

      if (familyKey && !scentFamilyMap.has(familyKey)) {
        scentFamilyMap.set(familyKey, { toggle: toggle, list: list, container: container });
      }

      setScentFamilyExpanded(familyKey, false);

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        setScentFamilyExpanded(familyKey, !expanded);
      });
    });

    unsubscribe = NativeCategoryFilter.subscribe(function (snapshot) {
      applyState(snapshot);
    });

    applyState(NativeCategoryFilter.getState());

    root.dataset.sidebarFilterInitialized = 'true';

    window.addEventListener('unload', function () {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-variant-scent-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    var containers = Array.prototype.slice.call(document.querySelectorAll('[data-variant-scent-filter]'));

    if (!containers.length) {
      return;
    }

    function normalizeHandle(handle) {
      return (handle || '').toString().trim().toLowerCase();
    }

    function updateVisibility(container, snapshot) {
      if (!container) {
        return;
      }

      var shouldHide = !!(snapshot && snapshot.sidebarOpen);
      if (shouldHide) {
        container.setAttribute('hidden', '');
        container.style.display = 'none';
      } else {
        container.removeAttribute('hidden');
        container.style.display = '';
      }
    }

    function toggleHandle(handle, shouldSelect) {
      if (!window.NativeCategoryFilter) {
        return;
      }
      NativeCategoryFilter.handleCheckbox(handle, shouldSelect, {
        source: 'variant-horizontal',
        clearAncestorExplicit: false,
      });
    }

    function updateOverflowState(container, list) {
      if (!container || !list) {
        return;
      }
      var hasOverflow = list.scrollWidth > list.clientWidth + 1;
      container.setAttribute('data-scroll-has-overflow', hasOverflow ? 'true' : 'false');
    }

    function reorderItems(container, items, selectedOrder) {
      var list = container.querySelector('[data-variant-scent-items][data-scroll-target]') || container.querySelector('[data-variant-scent-items]');
      if (!list) {
        return;
      }

      items
        .slice()
        .sort(function (a, b) {
          var handleA = normalizeHandle(a.dataset.variantHandle);
          var handleB = normalizeHandle(b.dataset.variantHandle);
          var indexA = selectedOrder.indexOf(handleA);
          var indexB = selectedOrder.indexOf(handleB);
          var selectedA = indexA !== -1;
          var selectedB = indexB !== -1;

          if (selectedA && selectedB) {
            return indexA - indexB;
          }
          if (selectedA) {
            return -1;
          }
          if (selectedB) {
            return 1;
          }

          var originalA = parseInt(a.getAttribute('data-original-index'), 10) || 0;
          var originalB = parseInt(b.getAttribute('data-original-index'), 10) || 0;
          return originalA - originalB;
        })
        .forEach(function (item) {
          list.appendChild(item);
        });

      updateOverflowState(container, list);
    }

    function updateState(container, items, snapshot, list) {
      if (!snapshot || !snapshot.checked) {
        return;
      }

      updateVisibility(container, snapshot);

      var selectedHandles = Array.from(snapshot.checked.values()).filter(function (handle) {
        var node = window.NativeCategoryFilter ? NativeCategoryFilter.getNode(handle) : null;
        return node && node.data && node.data.group_type === 'variant_scent';
      });

      var normalized = selectedHandles.map(normalizeHandle);
      var selectedSet = new Set(normalized);

      items.forEach(function (item) {
        var handle = normalizeHandle(item.dataset.variantHandle);
        var isSelected = selectedSet.has(handle);

        item.dataset.selected = isSelected ? 'true' : 'false';
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (isSelected) {
          item.classList.add('is-selected');
        } else {
          item.classList.remove('is-selected');
        }
      });

      reorderItems(container, items, normalized);
    }

    containers.forEach(function (container) {
      if (container.dataset.variantFilterInitialized === 'true') {
        return;
      }

      var items = Array.prototype.slice.call(container.querySelectorAll('[data-variant-handle]'));
      var list = container.querySelector('[data-variant-scent-items][data-scroll-target]') || container.querySelector('[data-variant-scent-items]');
      if (!items.length) {
        return;
      }

      items.forEach(function (item) {
        item.addEventListener('click', function (event) {
          if (!window.NativeCategoryFilter) {
            return;
          }

          var handle = normalizeHandle(item.dataset.variantHandle);
          if (!handle) {
            return;
          }

          if (event.target && event.target.closest('[data-variant-remove]')) {
            event.preventDefault();
            event.stopPropagation();
            toggleHandle(handle, false);
            return;
          }

          var shouldSelect = item.dataset.selected !== 'true';
          toggleHandle(handle, shouldSelect);
        });
      });

      if (list) {
        list.addEventListener('scroll', function () {
          updateOverflowState(container, list);
        });
      }

      if (window.NativeCategoryFilter && typeof window.NativeCategoryFilter.subscribe === 'function') {
        NativeCategoryFilter.subscribe(function (snapshot) {
          updateState(container, items, snapshot, list);
        });
        updateState(container, items, NativeCategoryFilter.getState(), list);
      }

      updateOverflowState(container, list);
      container.dataset.variantFilterInitialized = 'true';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-section"] && !Shopify.designMode) return;
  try {
    let isAnimating = false;

  const onScrollAnimatePromo = () => {
    if (isAnimating) return;
    isAnimating = true;

    requestAnimationFrame(() => {
      const viewportHeight = window.innerHeight;

      document.querySelectorAll('.promo-section-animation').forEach(promoSection => {
        const sectionPosition = promoSection.getBoundingClientRect();
        const promoText = promoSection.querySelector('.media-with-content__content-wrapper');
        const promoImage = promoSection.querySelector('.media-with-content__media-wrapper');
        if (!promoText || !promoImage) return;

        const animationStartY = viewportHeight * 0.6;
        const animationEndY = viewportHeight * 0.01;
        const progress = (viewportHeight - sectionPosition.top - animationEndY) / (animationStartY - animationEndY);
        const progressClamped = Math.max(0, Math.min(1, progress));

        const textTranslateY = -100 * (1 - progressClamped);
        const imageTranslateY = 60 * (1 - progressClamped);

        promoText.style.transform = `translateY(${textTranslateY}px)`;
        promoImage.style.transform = `translateY(${imageTranslateY}px)`;
      });

      isAnimating = false;
    });
  };

  document.addEventListener('scroll', onScrollAnimatePromo, { passive: true });
  } catch(e) { console.error(e); }
})();

})();
